import { createColumnDate, createColumnInput, createColumnSelect } from "../../../../components/table/c-table.logic";
import i18n from "../../../../i18n";
import store from "../../../../store";
import lodash from "lodash";

import {
    createFieldCheckbox,
    createFieldDate,
    createFieldInput,
    createFieldInputNumber,
    createFieldRadioGroup,
    createFieldSelect,
    createFieldTextArea
} from "../../../../components/input/template-builder/template-builder.logic";
import { defineAsyncComponent } from "vue";
import { conditionFormChecker, putField } from "../../../../utils/form";
import { Button, Divider, Tooltip } from "ant-design-vue";
import {
    callFindChildrenByIdAndRequestNo,
    callSave,
    copyForm,
    createReportData,
} from "./certificate-request.logic";
import { openModalForm as openModalFormHologramNo } from "../hologram-number-form/hologram-no-form.logic";
import { setIsLoading as setIsLoadingApp } from "../../../../app.logic";
import { createConditionAction } from "@/views/app/certificate/certificate-request/certificate-request.condition";
import router from "@/router";
import {filter} from "@/utils/search";
import { openModalReportList } from "../../report/report.logic";
import {validateNotification} from "@/utils/validate";
import {has} from "@/utils/menu-context";

export const callTransportMode = ({ searchQuery }) => store.dispatch('resource/v1/master/lookup/cacheFindAllByGroup', { group: 'TRANSPORTATION_MODES', value: searchQuery })
export const callStatusRequest = ({ searchQuery }) => store.dispatch('resource/v1/master/lookup/cacheFindAllByGroup', { group: 'CERTIFICATE_REQUEST_STATUS', value: searchQuery, options: { force: true } })
export const callRequestForm = ({ searchQuery }) => store.dispatch('resource/v1/master/lookup/cacheFindAllByGroup', { group: 'REQUEST_FORM', value: searchQuery, options: { force: true } })
export const callIntransitMethod = ({ searchQuery }) => store.dispatch('resource/v1/master/lookup/cacheFindAllByGroup', { group: 'INTRANSIT_METHOD', value: searchQuery })
export const callTransportTemperatureType = ({ searchQuery }) => store.dispatch('resource/v1/master/lookup/cacheFindAllByGroup', { group: 'TRANSPORT_TEMPERATURE_TYPE', value: searchQuery })
export const callExportAmountUnit = ({ searchQuery }) => store.dispatch('resource/v1/master/lookup/cacheFindAllByGroup', { group: 'EXPORT_AMOUNT_UNIT', value: searchQuery })
export const callIsAquaculture = ({ searchQuery }) => store.dispatch('resource/v1/master/lookup/cacheFindAllByGroup', { group: 'IS_AQUACULTURE', value: searchQuery })
export const callIsWildCaught = ({ searchQuery }) => store.dispatch('resource/v1/master/lookup/cacheFindAllByGroup', { group: 'IS_WILD_CAUGHT', value: searchQuery })
export const callProducedOn = ({ searchQuery }) => store.dispatch('resource/v1/master/lookup/cacheFindAllByGroup', { group: 'PRODUCT_ON', value: searchQuery })
export const callHumanConsumption = ({ searchQuery }) => store.dispatch('resource/v1/master/lookup/cacheFindAllByGroup', { group: 'HUMAN_CONSUMPTION', value: searchQuery })
export const callRequestChangeInformationTopic = ({ searchQuery }) => store.dispatch('resource/v1/master/lookup/cacheFindAllByGroup', { group: 'REQUEST_CHANGE_INFORMATION_TOPIC', value: searchQuery })
export const callRequestType = ({ searchQuery }) => store.dispatch('resource/v1/master/lookup/cacheFindAllByGroup', { group: 'CERTIFICATE_REQUEST_TYPE', value: searchQuery })
export const callReportAddressCase = ({ searchQuery }) => store.dispatch("resource/v1/master/lookup/cacheFindAllByGroup", { group: "REPORT_ADDRESS_CASE", value: searchQuery });
export const callCountry = ({ searchQuery }) => store.dispatch('resource/v1/master/country/cacheFindAll', { nameTh: searchQuery, nameEn: searchQuery, options: { force: true }})
export const callDepartment = ({ searchQuery }) => store.dispatch('resource/v1/master/department/cacheFindAllResearchAndInspectionCenter', { nameTh: searchQuery, nameEn: searchQuery})
export const callProvince = ({ searchQuery }) => store.dispatch('resource/v1/master/province/cacheFindAll', { name: searchQuery, nameEn: searchQuery})
export const callCompanyCountries = ({ searchQuery, refCompanyId }) => store.dispatch('resource/v1/transaction/companyCountry/cacheFindAllCountryByRefCompanyId', { searchQuery, refCompanyId, options: { force: true } })
export const callMyCompanies = () => store.dispatch('resource/v1/transaction/userCompany/findAllMyCompanies', { userId: store.state.resource.auth.info?.user?.id })
export const callCharacterOfProductiveWaterArea = ({ searchQuery }) => store.dispatch("resource/v1/master/lookup/cacheFindAllByGroup", { group: "CHARACTER_OF_PRODUCTIVE_WATER_AREA", value: searchQuery });
export const callProcessingType = ({ searchQuery }) => store.dispatch("resource/v1/master/lookup/cacheFindAllByGroup", { group: "PROCESSING_TYPE", value: searchQuery });

const CIcon = defineAsyncComponent(() => import("../../../../components/icon/CIcon"));
const Address = defineAsyncComponent(() => import('../../../../components/address/Address'))
const CardBorder = defineAsyncComponent(() => import('../../../../components/card/CardBorder'))
const TemplateBuilder = defineAsyncComponent(() => import('../../../../components/input/template-builder/TemplateBuilder'))
const AttachmentList = defineAsyncComponent(() => import("../../attachment/AttachmentList"))
const CertificateProductList = defineAsyncComponent(() => import("../certificate-product/CertificateProductList"))
const CertificateAquaticScientificNameList = defineAsyncComponent(() => import("./CertificateAquaticScientificNameList"))
const CertificateFarmLocationList = defineAsyncComponent(() => import("./CertificateFarmLocationList"))

export const createColumns = ({ props }) => {
    const { menuContext, isTmp } = props
    const columnTemplate = (isTmp && (has({ menuContext, key: 'forCertificateSigner' }) || has({ menuContext, key: 'forCertificateApprover' })) ) ?
        "template4" : props.columnTemplate
    const columns = [
        createColumnDate({
            title: () => i18n.global.t("model.certificateRequest.requestDate"),
            dataIndex: "requestDate",
            inputProp: () => ({locale: 'en'}),
            align: "center",
            format: 'DD/MM/YYYY',
            locale: 'en'
        }),
        createColumnDate({
            title: () => i18n.global.t("model.certificateRequest.editCertificateDate"),
            dataIndex: "editCertificateDate",
            inputProp: () => ({locale: 'en'}),
            format: 'DD/MM/YYYY',
            align: "center",
            locale: 'en'
        }),
        createColumnInput({
            title: () => i18n.global.t("model.certificateRequest.requestNo"),
            dataIndex: "requestNo",
            align: "center",
        }),
        createColumnInput({
            title: () => i18n.global.t("model.certificateRequest.requestChangeInformationNo"),
            dataIndex: "requestChangeInformationNo",
            align: "center",
        }),
        createColumnSelect({
            title: () => i18n.global.t('model.certificateRequest.refRequestChangeInformationTopic'),
            dataIndex: 'refRequestChangeInformationTopic.value',
            customRender: ({ record }) => <div>{record.refRequestChangeInformationTopic?.value}</div>,
            inputProp: () => ({
                list: callRequestChangeInformationTopic,
                renderLabel: ({ item }) => <div>{item.value}</div>,
            }),
            align: "center",
            search: {
                name: "refRequestChangeInformationTopic.id"
            }
        }),
        createColumnInput({
            title: () => i18n.global.t("model.company.nameEn"),
            dataIndex: "refCompany.nameEn",
            align: "center",
        }),
        createColumnInput({
            title: () => i18n.global.t("model.company.thNo"),
            dataIndex: "refCompany.thNo",
            align: "center",
        }),
        createColumnSelect({
            title: () => i18n.global.t("model.certificateRequest.samplingLv"),
            dataIndex: "refRequestType.value",
            inputProp: () => ({
                list: callRequestType,
                renderLabel: ({ item }) => <div>{item.value}</div>,
            }),
            align: "center",
            search: {
                name: "refRequestType.id"
            }
        }),
        createColumnSelect({
            title: () => i18n.global.t('model.certificateRequest.refExportCountry'),
            dataIndex: 'refExportCountry.nameEn',
            inputProp: () => ({
                list: callCountry,
                renderLabel: ({ item }) => <div>{item.nameTh} ({item.nameEn})</div>,
            }),
            align: "center",
            search: {
                name: "refExportCountry.id"
            }
        }),
        createColumnSelect({
            title: () => i18n.global.t('model.certificateRequest.refTransportMode'),
            dataIndex: 'refTransportMode.value',
            inputProp: () => ({
                list: callTransportMode,
                renderLabel: ({ item }) => <div>{item.value}</div>,
            }),
            align: "center",
            search: {
                name: "refTransportMode.id"
            }
        }),
        createColumnInput({
            title: () => i18n.global.t("model.requestChangeCertificateInformation.requester"),
            dataIndex: "requester",
            align: "center",
        }),
        createColumnSelect({
            title: () => !isTmp ? i18n.global.t('model.certificateRequest.statusRequest') : i18n.global.t('model.certificateRequest.statusRequestChangeInformation'),
            dataIndex: 'refRequestStatus.value',
            customRender: ({ record }) => <div>{record.refRequestStatus?.value}</div>,
            inputProp: () => ({
                list: callStatusRequest,
                optLabel: 'value',
                renderLabel: ({ item }) => <div>{item.value}</div>,
            }),
            align: "center",
            search: {
                name: "refRequestStatus.id"
            }
        }),
        createColumnDate({
            title: () => i18n.global.t("model.certificateRequest.certificateApprovalDate"),
            dataIndex: "certificateApprovalDate",
            inputProp: () => ({locale: 'en'}),
            align: "center",
            format: 'DD/MM/YYYY',
            locale: 'en'
        }),
        createColumnInput({
            title: () => i18n.global.t("model.certificateRequest.certificateNo"),
            dataIndex: "certificateNo",
            align: "center",
            width: 200,
            customRender: ({ record }) => {
                const conditionAction =  createConditionAction()
                const callBack = () => {
                    setIsLoadingApp(true)
                    record.isPrinted = false
                    callSave({ form: record })
                        .finally(() => {
                            record.version = record.version + 1
                            return setIsLoadingApp(false)
                        })
                }
                return conditionAction.canEditHologramNo({props, record}) ?
                    <div>
                        <span style={"text-decoration: underline; color: blue;"}
                            onClick={ () => {
                                    callFindChildrenByIdAndRequestNo({ requestNo: record.requestNo, id: record.id }).then(children => {
                                        if (children.filter(d => !d.isDelete && ["Wait", "Approve"].includes(d?.refRequestStatus?.key)).length) {
                                            validateNotification({ message: i18n.global.t('error.form.haveRequestChange')})
                                        } else {
                                            openModalFormHologramNo({props: { form: record, ...props }, callBack})
                                        }
                                    })
                                }
                            }>
                            { record.certificateNo }
                        </span>
                    </div> : <div><span>{ record.certificateNo }</span></div>
            }
        }),
        createColumnInput({
            title: () => i18n.global.t("model.certificateRequest.hologramNo"),
            dataIndex: "hologramNo1",
            align: "center",
            customRender: ({ record }) => {
                return record.hologramNo2 ? <span>{record.hologramNo1}, {record.hologramNo2}</span> : <span>{record.hologramNo1}</span>
                }
            }),
        {
            dataIndex: "printReport",
            visible: () => true,
            title: () => i18n.global.t('model.certificateRequest.labels.printCertificate'),
            customRender: ({ record }) => {
                return <Button class="btn-info m-1" shape="circle"
                        onClick={() => {
                                callFindChildrenByIdAndRequestNo({ requestNo: record.requestNo, id: record.id }).then(children => {
                                    if (children.filter(d => !d.isDelete && ["Wait", "Approve"].includes(d?.refRequestStatus?.key)).length) {
                                        validateNotification({ message: i18n.global.t('error.form.haveRequestChange')})
                                    } else {
                                        const data = {};
                                        data.reports = createReportData({ props, modelRef: record, id: record.id })
                                        openModalReportList({ props, data });
                                    }
                                })
                            }
                        }><CIcon file="printer.svg" /></Button>
                },
            showText: () => false,
            sorter: false,
            width: 100,
            align: 'center',
            search: {visible: () => false},
        },
        createColumnInput({
            title: () => i18n.global.t("model.certificateRequest.refAssignedTo"),
            dataIndex: "refAssignedTo.fullName",
            align: "center",
        }),
        {
            dataIndex: "saveAs",
            visible: () => true,
            title: () => i18n.global.t('model.certificateRequest.labels.saveAs'),
            customRender: ({ record }) => {
                return <Button class="btn-danger m-1" shape="circle"
                        onClick={ () => {
                                const form = copyForm({ form: record });
                                form.requestNo = null
                                form.refRequestStatus = null
                                form.requestDate = null
                                form.certificateNo = null
                                form.refAssignedTo = null
                                form.requester = null
                                form.correctionDetail = null
                                form.certificateApprovalDate = null
                                form.certificateDate = null
                                form.editCertificateDate = null
                                form.approverRemark = null
                                form.hologramNo1 = null
                                form.hologramNo2 = null
                                form.isPrinted = false
                                form.cancelDate = null;
                                form.qty = null;
                                form.refExportAmountUnit = null;
                                form.runningNo = null
                                form.certificateProducts = []
                                form.children = []
                                const isAllModels = record.isAllModels
                                const routerPrefix = isAllModels ? 'certificate-request-all-models' : 'certificate-requests'
                                router.push({
                                    name: `${routerPrefix}-create`,
                                    params: { props: JSON.stringify({ form }) }
                                });
                            }
                        }
                ><CIcon file="copy.svg" /></Button>
            },
            showText: () => false,
            sorter: false,
            width: 100,
            align: 'center',
            search: {visible: () => false},
        },
    ]

    const template1 = [
        "requestDate", "certificateApprovalDate", "requestNo", "certificateNo", "refExportCountry.nameEn", "requester", "refRequestStatus.value", "printReport", "saveAs", "editCertificateDate"
    ]
    const template2 = [
        "requestDate", "requestNo", "requestChangeInformationNo", "refRequestChangeInformationTopic.value", "requester", "refRequestStatus.value"
    ]
    const template3 = [
        "requestDate", "requestNo", "refCompany.nameEn", "refCompany.thNo", "refRequestType.value", "refExportCountry.nameEn", "refRequestStatus.value",
         "refTransportMode.value", "refRequestStatus.value", "certificateApprovalDate", "certificateNo", "hologramNo1", "printReport", "refAssignedTo.fullName"
    ]
    const template4 = [
        "requestDate", "requestNo", "requestChangeInformationNo", "refCompany.nameEn", "refCompany.thNo", "refRequestStatus.value", "certificateNo", "printReport", "hologramNo1"
    ]
    if (columnTemplate === "template1") return columns.filter(d=>template1.includes(d.dataIndex))
    if (columnTemplate === "template2") return columns.filter(d=>template2.includes(d.dataIndex))
    if (columnTemplate === "template3") return columns.filter(d=>template3.includes(d.dataIndex))
    if (columnTemplate === "template4") return columns.filter(d=>template4.includes(d.dataIndex))
    return columns
}

export const createField = ({ props, data/*, refs*/, key, isLoading }) => {
    const { viewOnly, menuContext } = props
    const { useForm } = data
    const { modelRef } = useForm
    const model = key ? lodash.get(modelRef, key) : modelRef
    return putField({
        data, fields: [
            {
                visible: () => conditionFormChecker({ props, data, executeKey: 'visibleSection', params: { sectionKey: 'CompanyDetail' } }),
                colProp: () => ({ xs: 24 }),
                formItemRender: () => {
                    return <CardBorder title={i18n.global.t('views.company.title')}>
                        <TemplateBuilder
                            rowProp={data.rowProp}
                            useForm={useForm}
                            fields={createFieldCompanyDetail({ props, data, key, isLoading })}
                            skeleton={isLoading.value}
                        ></TemplateBuilder>
                    </CardBorder>
                }
            },
            {
                visible: () => conditionFormChecker({ props, data, executeKey: 'visibleSection', params: { sectionKey: 'ExportCountry' } }),
                colProp: () => ({ xs: 24 }),
                formItemRender: () => {
                    return <CardBorder title={i18n.global.t('views.company.companyCountry.title')}>
                        <TemplateBuilder
                            rowProp={data.rowProp}
                            useForm={useForm}
                            fields={createFieldExportCountry({ props, data, key, isLoading })}
                            skeleton={isLoading.value}
                        ></TemplateBuilder>
                    </CardBorder>
                }
            },
            {
                visible: () => conditionFormChecker({ props, data, executeKey: 'visibleSection', params: { sectionKey: 'CertificateProduct' } }),
                colProp: () => ({ xs: 24 }),
                formItemRender: () => {
                    const cardProp = lodash.merge({
                        title: i18n.global.t('views.company.companyRequest.attachment.title'),
                    }, conditionFormChecker({ props, data, executeKey: 'cardProp', params: { sectionKey: 'CertificateProduct' } }))
                    const componentProp = lodash.merge({
                        menuContext,
                        viewOnly: viewOnly,
                        dataProp: data,
                        itemsKey: 'certificateProducts',
                        isTmp: model.isTmp,
                        canAddProduct: true,
                        visibleSearch: false
                        /*
                                                ref: e => lodash.set(refs, 'certificateProductList', e),
                        */
                    }, conditionFormChecker({ props, data, executeKey: 'componentProp', params: { sectionKey: 'CertificateProduct' } }))
                    return <CardBorder id={"cardCertificateProducts"} {...cardProp}>
                        <CertificateProductList {...componentProp}></CertificateProductList>
                    </CardBorder>
                }
            },
            {
                visible: () => conditionFormChecker({ props, data, executeKey: 'visibleSection', params: { sectionKey: 'ProducerDetail' } }),
                colProp: () => ({ xs: 24 }),
                formItemRender: () => {
                    return <CardBorder title={i18n.global.t('model.certificateRequest.producerDetail')}>
                        <TemplateBuilder
                            rowProp={data.rowProp}
                            useForm={useForm}
                            fields={createFieldProducerDetail({ props, data, key, isLoading })}
                            skeleton={isLoading.value}
                        ></TemplateBuilder>
                    </CardBorder>
                }
            },
            {
                visible: () => conditionFormChecker({ props, data, executeKey: 'visibleSection', params: { sectionKey: 'ExporterDetail' } }),
                colProp: () => ({ xs: 24 }),
                formItemRender: () => {
                    return <CardBorder title={i18n.global.t('model.certificateRequest.exporterDetail')}>
                        <TemplateBuilder
                            rowProp={data.rowProp}
                            useForm={useForm}
                            fields={createFieldExporterDetail({ props, data, key, isLoading })}
                            skeleton={isLoading.value}
                        ></TemplateBuilder>
                    </CardBorder>
                },
            },
            {
                visible: () => conditionFormChecker({ props, data, executeKey: 'visibleSection', params: { sectionKey: 'ConsigneeDetail' } }),
                colProp: () => ({ xs: 24 }),
                formItemRender: () => {
                    return <CardBorder title={i18n.global.t('model.certificateRequest.consigneeDetail')}>
                        <TemplateBuilder
                            rowProp={data.rowProp}
                            useForm={useForm}
                            fields={createFieldConsigneeDetail({ props, data, key, isLoading })}
                            skeleton={isLoading.value}
                        ></TemplateBuilder>
                    </CardBorder>
                }
            },
            {
                visible: () => conditionFormChecker({ props, data, executeKey: 'visibleSection', params: { sectionKey: 'ProductDetail' } }),
                colProp: () => ({ xs: 24 }),
                formItemRender: () => {
                    return <CardBorder title={i18n.global.t('model.certificateRequest.productDetail')}>
                        <TemplateBuilder
                            rowProp={data.rowProp}
                            useForm={useForm}
                            fields={createFieldProductDetail({ props, data, key, isLoading })}
                            skeleton={isLoading.value}
                        ></TemplateBuilder>
                    </CardBorder>
                },
            },
            {
                visible: () => conditionFormChecker({ props, data, executeKey: 'visibleSection', params: { sectionKey: 'TransportDetail' } }),
                colProp: () => ({ xs: 24 }),
                formItemRender: () => {
                    return <CardBorder title={i18n.global.t('model.certificateRequest.transportDetail')}>
                        <TemplateBuilder
                            rowProp={data.rowProp}
                            useForm={useForm}
                            fields={createFieldTransportDetail({ props, data, key, isLoading })}
                            skeleton={isLoading.value}
                        ></TemplateBuilder>
                    </CardBorder>
                },
            },
            {
                visible: () => conditionFormChecker({ props, data, executeKey: 'visibleSection', params: { sectionKey: 'CertificateRequestAttachment' } }),
                colProp: () => ({ xs: 24 }),
                formItemRender: () => {
                    return <CardBorder title={i18n.global.t('views.company.register.attachment.title')}>
                        <TemplateBuilder
                            rowProp={data.rowProp}
                            useForm={useForm}
                            fields={createFieldCertificateRequestAttachment({ props: { ...props }, data, key, isLoading })}
                            skeleton={isLoading.value}
                        ></TemplateBuilder>
                    </CardBorder>
                },
            },
            {
                visible: () => conditionFormChecker({ props, data, executeKey: 'visibleSection', params: { sectionKey: 'MoreInformation' } }),
                colProp: () => ({ xs: 24 }),
                formItemRender: () => {
                    return <CardBorder title={i18n.global.t('model.certificateRequest.moreInformation')}>
                        <TemplateBuilder
                            rowProp={data.rowProp}
                            useForm={useForm}
                            fields={createFieldMoreInformation({ props, data, key, isLoading })}
                            skeleton={isLoading.value}
                        ></TemplateBuilder>
                    </CardBorder>
                },
            },
            {
                visible: () => conditionFormChecker({ props, data, executeKey: 'visibleSection', params: { sectionKey: 'CorrectionDetail' } }),
                colProp: () => ({ xs: 24 }),
                formItemRender: () => {
                    return <CardBorder title={i18n.global.t('model.certificateRequest.labels.correctionDetail')}>
                        <TemplateBuilder
                            rowProp={data.rowProp}
                            useForm={useForm}
                            fields={createFieldCorrectionDetails({ props, data, key, isLoading })}
                            skeleton={isLoading.value}
                        ></TemplateBuilder>
                    </CardBorder>
                },
            },
            {
                visible: () => conditionFormChecker({ props, data, executeKey: 'visibleSection', params: { sectionKey: 'OfficerPart' } }),
                colProp: () => ({ xs: 24 }),
                formItemRender: () => {
                    return <CardBorder title={i18n.global.t('views.section.officer')}>
                        <TemplateBuilder
                            rowProp={data.rowProp}
                            useForm={useForm}
                            fields={createFieldOfficerPart({ props: { ...props }, data, key, isLoading })}
                            skeleton={isLoading.value}
                        ></TemplateBuilder>
                    </CardBorder>
                },
            },
        ]
    })
}

export const createFieldCompanyDetail = ({ props, data, key, isLoading }) => {
    const { viewOnly, menuContext } = props
    const { useForm } = data
    const { modelRef } = useForm
    const model = key ? lodash.get(modelRef, key) : modelRef
    const prefix = key ? `${key}.` : ''
    return putField({
        data, fields: [
            createFieldSelect({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: 'visibleField', params: { field } }),
                key: `${prefix}refCompany`,
                colProp: () => ({ xs: 24, md: 20 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 6 }, wrapperCol: { xs: 24, md: 18 } }),
                label: () => i18n.global.t('model.certificateRequest.refCompany') ,
                labelRender: ({ field }) => checkTooltipLabel({ field, keySuffix: "nameTh", labelTitle: field.label(), parentModel: model.refParent, model}),
                inputProp: ({ field }) => (lodash.merge({
                    value: model.refCompany,
                    'onUpdate:value': value => model.refCompany = value,
                    disabled: viewOnly,
                    list: callMyCompanies,
                    optLabel: "nameTh",
                }, conditionFormChecker({ props, data, executeKey: 'inputPropField', params: { field } }))),
                changeLog: { getValue: ({ record, field }) => lodash.get(record, `${field.key}.nameTh`) }
            }),
            createFieldInput({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: 'visibleField', params: { field } }),
                key: `${prefix}requestNo`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 6 }, wrapperCol: { xs: 24, md: 18 } }),
                label: () => i18n.global.t('model.certificateRequest.requestNo'),
                inputProp: ({ field }) => (lodash.merge({
                    value: model.requestNo,
                }, conditionFormChecker({ props, data, executeKey: 'inputPropField', params: { field } }))),
            }),
            createFieldSelect({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: 'visibleField', params: { field } }),
                key: `${prefix}refDepartment`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 6 }, wrapperCol: { xs: 24, md: 18 } }),
                label: () => i18n.global.t('model.certificateRequest.refDepartment'),
                labelRender: ({ field }) => checkTooltipLabel({ field, keySuffix: "nameTh", labelTitle: field.label(), parentModel: model.refParent, model}),
                inputProp: ({ field }) => (lodash.merge({
                    value: model.refDepartment,
                    'onUpdate:value': value => model.refDepartment = value,
                    disabled: viewOnly,
                    list: callDepartment,
                    optLabel: "nameTh",
                }, conditionFormChecker({ props, data, executeKey: 'inputPropField', params: { field } }))),
                changeLog: { getValue: ({ record, field }) => lodash.get(record, `${field.key}.nameTh`) }
            }),
            createFieldInput({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: 'visibleField', params: { field } }),
                key: `${prefix}requestChangeInformationNo`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 6 }, wrapperCol: { xs: 24, md: 18 } }),
                label: () => i18n.global.t('model.certificateRequest.requestChangeInformationNo'),
                inputProp: ({ field }) => (lodash.merge({
                    value: model.requestChangeInformationNo,
                }, conditionFormChecker({ props, data, executeKey: 'inputPropField', params: { field } }))),
            }),
            {
                key: `${prefix}requestChangeInformationNo`,
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: 'visibleField', params: { field } }),
                colProp: () => ({ xs: 24, md: 12 }),
                formItemRender: () => {
                }
            },
            createFieldDate({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: 'visibleField', params: { field } }),
                key: `${prefix}requestDate`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 6 }, wrapperCol: { xs: 24, md: 18 } }),
                label: () => i18n.global.t('model.certificateRequest.requestDate'),
                inputProp: ({ field }) => (lodash.merge({
                    value: model.requestDate,
                    'onUpdate:value': value => (model.requestDate = value),
                    disabled: true,
                    locale: 'en',
                }, conditionFormChecker({ props, data, executeKey: 'inputPropField', params: { field } }))),
            }),
            {
                visible: () => true,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemRender: () => {
                }
            },
            createFieldInput({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: 'visibleField', params: { field } }),
                key: `${prefix}requester`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 6 }, wrapperCol: { xs: 24, md: 18 } }),
                label: () => i18n.global.t('model.certificateRequest.requester'),
                inputProp: ({ field }) => (lodash.merge({
                    value: model.requester,
                    disabled: true,
                }, conditionFormChecker({ props, data, executeKey: 'inputPropField', params: { field } }))),
            }),
            {
                visible: () => true,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemRender: () => {
                }
            },
            createFieldInput({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: 'visibleField', params: { field } }),
                key: `${prefix}refCompany.nameEn`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 6 }, wrapperCol: { xs: 24, md: 18 } }),
                label: () => i18n.global.t('model.company.name'),
                inputProp: ({ field }) => (lodash.merge({
                    value: model.refCompany?.nameEn,
                }, conditionFormChecker({ props, data, executeKey: 'inputPropField', params: { field } }))),
            }),
            {
                visible: () => true,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemRender: () => {
                }
            },
            createFieldInput({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: 'visibleField', params: { field } }),
                key: `${prefix}refCompany.thNo`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 6 }, wrapperCol: { xs: 24, md: 18 } }),
                label: () => i18n.global.t('model.company.thNo'),
                inputProp: ({ field }) => (lodash.merge({
                    value: model.refCompany?.thNo,
                }, conditionFormChecker({ props, data, executeKey: 'inputPropField', params: { field } }))),
            }),
            {
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: 'visibleField', params: { field } }),
                colProp: () => ({ xs: 24, md: 24 }),
                formItemRender: () => {
                    model?.refCompany; // must beacuse when change refCompany then reactive new pointer need rerender
                    return () => !model?.refCompany ? <span></span> : <div><Divider class="my-3" orientation="left">{i18n.global.t('model.company.refFactoryAddrEn')}</Divider>
                        <Address menuContext={menuContext} dataProp={data}
                                 dataKey={`${prefix}refCompany.refFactoryAddrEn`}
                                 ref={e => data.fields[`${prefix}refCompany.refFactoryAddrEn`] = e?.data.fields}
                                 viewOnly={true} isLoading={isLoading.value} locale="En"
                        ></Address></div>
                }
            },
            createFieldInput({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: 'visibleField', params: { field } }),
                key: `${prefix}refCompany.branch`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 6 }, wrapperCol: { xs: 24, md: 18 } }),
                label: () => i18n.global.t('model.company.branch'),
                inputProp: ({ field }) => (lodash.merge({
                    value: model.refCompany?.branch,
                }, conditionFormChecker({ props, data, executeKey: 'inputPropField', params: { field } }))),
            }),
        ]
    })
}

export const createFieldExportCountry = ({ props, data, key }) => {
    const { viewOnly } = props
    const { useForm } = data
    const { modelRef } = useForm
    const model = key ? lodash.get(modelRef, key) : modelRef
    const prefix = key ? `${key}.` : ''
    return putField({
        data, fields: [
            createFieldSelect({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: 'visibleField', params: { field } }),
                key: `${prefix}refExportCountry`,
                colProp: () => ({ xs: 24, md: 16 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t('model.certificateRequest.refExportCountry'),
                labelRender: ({ field }) => checkTooltipLabel({ field, keySuffix: "nameEn", labelTitle: field.label(), parentModel: model.refParent, model }),
                inputProp: ({ field }) => (lodash.merge({
                    value: model.refExportCountry,
                    'onUpdate:value': value => {
                        model.refExportCountry = value
                        model.isoExportCountry = value?.isoTwoDigit?.[0]?.code
                        store.dispatch('resource/v1/master/lookup/cacheFindAllByGroup', { group: 'REQUEST_FORM',  options: { force: true } })
                            .then( list => {
                                // const val = list.filter(form => form.attribute.countriesOfUse.includes(value.alpha))
                                const val = list.filter(form => form.attribute.countriesOfUse.includes(value.alpha)).length > 0 ?
                                    list.filter(form => form.attribute.countriesOfUse.includes(value.alpha))
                                    : list.filter(form => form.key === 'dof_health_cert')
                                model.refRequestForm = filter({list: val, where: [], sort: [{ name: "value", type: "ASC" }]})?.[0]
                            })
                    },
                    disabled: viewOnly && !model.isTmp,
                    // list: () => {
                    //     return store.dispatch('resource/v1/master/country/cacheFindAll', { options: { force: true }})
                    //         .then(arr => {
                    //             return filter({
                    //                 list: arr,
                    //                 where: [],
                    //                 sort: [{ name: "nameEn", type: "ASC" }] })
                    //     })
                    // },
                    list:  ({ searchQuery }) => {
                        const where =  [
                            { name: 'isSpecial', operator: '=', value: false },
                            { name: 'haveChildren', operator: '=', value: false },
                        ]
                        return Promise.all([callCompanyCountries({ refCompanyId: modelRef.refCompany?.id }), store.dispatch('resource/v1/master/country/cacheFindAll', { where, options: { force: true }})])
                            .then(arr => {
                                const allComapnyCountry = arr[0].flatMap(d => d.children.length > 0 ? d.children : [d])
                                const allComapnyCountryId = allComapnyCountry.map(c => c.id)
                                const allIsNotSpecialCountry = arr[1].filter(d => !allComapnyCountryId.includes(d.id))
                                const listExportCountries = [...new Set([...allComapnyCountry,...allIsNotSpecialCountry])]

                                return filter({
                                    list: listExportCountries,
                                    where: [
                                        { name: "alpha", type: "String", isNot: true, operator: 'in', value: ['THA', 'DOF'] },
                                        { openBucket: true, name: "nameEn", type: "String", operator: 'like', value: searchQuery },
                                        { closeBucket: true, logic: 'OR', name: "nameTh", type: 'String', operator: 'like', value: searchQuery }
                                    ],
                                    sort: [{ name: "nameEn", type: "ASC" }] })
                            })
                    },
                    optKey: "id",
                    optLabel: "nameEn",
                }, conditionFormChecker({ props, data, executeKey: 'inputPropField', params: { field } }))),
                changeLog: { getValue: ({ record, field }) => lodash.get(record, `${field.key}.nameEn`) }
            }),
            createFieldSelect({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: 'visibleField', params: { field } }),
                key: `${prefix}isoExportCountry`,
                colProp: () => ({ xs: 24, md: 7 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 12 }, wrapperCol: { xs: 24, md: 12 } }),
                label: () => i18n.global.t('model.certificateRequest.isoExportCountry') ,
                labelRender: ({ field }) => checkTooltipLabel({ field, labelTitle: field.label(), parentModel: model.refParent, model }),
                inputProp: ({ field }) => (lodash.merge({
                    value: { code: model.isoExportCountry },
                    'onUpdate:value': value => {
                        model.isoExportCountry = value?.code
                    },
                    list: () => Promise.resolve(model?.refExportCountry?.isoTwoDigit).then(iso => (iso)),
                    optKey: "code",
                    optLabel: "code",
                    disabled: viewOnly ,
                }, conditionFormChecker({ props, data, executeKey: 'inputPropField', params: { field } }))),
                changeLog: { getValue: ({ record, field }) => lodash.get(record, `${field.key}`) }
            }),
            {
                visible: () => true,
                colProp: () => ({ xs: 24, md: 1 }),
                formItemRender: () => {
                }
            },
            createFieldSelect({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: 'visibleField', params: { field } }),
                key: `${prefix}refRequestForm`,
                colProp: () => ({ xs: 24, md: 16 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t('model.certificateRequest.refRequestForms'),
                labelRender: ({ field }) => checkTooltipLabel({ field, keySuffix: "value", labelTitle: field.label(), parentModel: model.refParent, model}),
                inputProp: ({ field }) => (lodash.merge({
                    value: model.refRequestForm,
                    'onUpdate:value': value => {
                        model.refRequestForm = value
                        model.typeOfTreatment =  null
                        model.hsCode =  null
                        model.regionOfOrigin =  null
                        model.approvalZone =  null
                        model.nameOfOperator =  null
                        model.addressOfOperator =  null
                        model.cityOfOperator =  null
                        model.postcodeOfOperator =  null
                        model.phoneNoOfOperator =  null
                        model.namePlaceOfDestination =  null
                        model.addressPlaceOfDestination =  null
                        model.accompanyingDocumentType =  null
                        model.accompanyingDocumentNo =  null
                        model.isCanningIndustry =  null
                        model.isHumanConsumption =  null
                        model.batchNo =  null
                        model.isFinalConsumer =  null
                        model.manufacturingDate =  null
                        model.expiredDate =  null
                        model.healthCertificateNo =  null
                        model.date =  null
                        model.refFromCountryOfOrigin =  null
                        model.isAquaculture =  null
                        model.isWildCaught =  null
                        model.refIsAquaculture =  null
                        model.aquacultureArea =  null
                        model.refIsWildCaught =  null
                        model.catchArea =  null
                        // model.catchVesselNameAndNo =  null
                        model.isProcessedDairyProduct =  null
                        model.refProducedInTheCountry =  null
                        model.approvalNo =  null
                        model.refProductOn =  null
                        model.productOnDate =  null
                        model.productOnBetweenDate1 =  null
                        model.productOnBetweenDate2 =  null
                        model.refApprovalCountry =  null
                        model.freezingDate =  null
                        model.refHumanConsumption =  null
                        model.farmLocations =  []
                        model.refCountryOfOriginOfRawMaterial = null
                        model.countryOfOriginOfRawMaterial = null
                        model.refCharacterOfProductiveWaterArea = null
                        model.aquacultureFarmNameAndRegistrationNo = null
                        model.fishVesselDetail = null
                        model.fishVesselFactoryDetail = null
                        model.transportVesselDetail = null
                        model.coldStorageMaterialDetail = null
                        model.coldStorageProductDetail = null
                        model.lotNoOfProduct = null
                        model.flightNo = null
                        model.otherTransportMean = null
                        model.imsocReference = null
                        model.isLiveAquaticAnimalForHumanConsumption = null
                        model.isFurtherProcessing = null
                        model.isForInternalMarket = null
                        model.coldStore = null
                        model.refOperatorCountry = null
                        model.refPlaceOfDestinationCountry = null
                        model.isoSourcePortCountry = null
                        model.isoOperatorCountry = null
                        model.isoPlaceOfDestinationCountry = null
                        // model.runningNo = null
                        model.regionOfDestination = null
                        model.approvalZone2 = null
                        model.regNoPlaceOfDestination = null
                        model.refAccompanyingDocumentCountry = null
                        model.isoAccompanyingDocumentCountry = null

                        model.slaughterhouse = null
                        model.dairyProducingCountries = null
                        model.euApprovalNo = null
                        model.isProduceDairyPeriod = false
                        model.dairyProduceStartDateStr = null
                        model.dairyProduceEndDateStr = null
                        model.eggOriginCountries = null
                    },
                    disabled: viewOnly,
                    // list: ({ searchQuery }) => {
                    //     return callRequestForm({ searchQuery })
                    //         .then(requestForms => {
                    //             const canUseForms = requestForms.filter(form => form?.attribute?.countriesOfUse.includes(model?.refExportCountry?.alpha) || form?.key == "dof_health_cert")
                    //             return filter({list: canUseForms, where: [], sort: [{ name: "value", type: "ASC" }]})
                    //         })
                    // },
                    list: callRequestForm,
                    optKey: "key",
                    optLabel: "value",
                }, conditionFormChecker({ props, data, executeKey: 'inputPropField', params: { field } }))),
                changeLog: { getValue: ({ record, field }) => lodash.get(record, `${field.key}.value`) }
            }),
            {
                visible: () => true,
                colProp: () => ({ xs: 24, md: 8 }),
                formItemRender: () => {
                }
            },
            createFieldSelect({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: 'visibleField', params: { field } }),
                key: `${prefix}refIntransitForm`,
                colProp: () => ({ xs: 24, md: 16 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t('model.certificateRequest.refIntransitForms'),
                labelRender: ({ field }) => checkTooltipLabel({ field, keySuffix: "value", labelTitle: field.label(), parentModel: model.refParent, model}),
                inputProp: ({ field }) => (lodash.merge({
                    value: model.refIntransitForm,
                    'onUpdate:value': value => model.refIntransitForm = value,
                    disabled: viewOnly,
                    list: callRequestForm,
                    optKey: "key",
                    optLabel: "value",
                    addonAfter: i18n.global.t('model.certificateRequest.refIntransitForms'),
                }, conditionFormChecker({ props, data, executeKey: 'inputPropField', params: { field } }))),
                changeLog: { getValue: ({ record, field }) => lodash.get(record, `${field.key}.value`) }
            })
        ]
    })
}

export const createFieldProducerDetail = ({ props, data, key }) => {
    const { viewOnly } = props
    const { useForm } = data
    const { modelRef } = useForm
    const model = key ? lodash.get(modelRef, key) : modelRef
    const prefix = key ? `${key}.` : ''
    return putField({
        data, fields: [
            createFieldRadioGroup({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}refReportProducerAddressCase`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.certificateRequest.refReportProducerAddressCase"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.refReportProducerAddressCase,
                            "onUpdate:value": value => {
                                model.refReportProducerAddressCase = value
                                formatProducerAddress({modelRef: model, format: value.key})
                            },
                            disabled: viewOnly,
                            list: ({ searchQuery }) => callReportAddressCase({searchQuery}).then(addrCase => (addrCase.filter(c => ["N", "U"].includes(c.key)))),
                            optLabel: "value"
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    ),
                changeLog: { getValue: ({ record, field }) => lodash.get(record, `${field.key}.value`) }
            }),
            {
                visible: () => true,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemRender: () => {
                }
            },
            createFieldInput({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: 'visibleField', params: { field } }),
                key: `${prefix}producerPlantName`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 6 }, wrapperCol: { xs: 24, md: 18 } }),
                label: () => i18n.global.t('model.certificateRequest.producerPlantName'),
                labelRender: ({ field }) => checkTooltipLabel({ field, labelTitle: field.label(), parentModel: model.refParent, model}),
                inputProp: ({ field }) => (lodash.merge({
                    value: model.producerPlantName,
                    //value.toUpperCase()
                    'onUpdate:value': value => model.producerPlantName = model?.refReportProducerAddressCase?.key === 'U' ? value?.toUpperCase() : value,
                    disabled: viewOnly,
                }, conditionFormChecker({ props, data, executeKey: 'inputPropField', params: { field } })))
            }),
            {
                visible: () => true,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemRender: () => {
                }
            },
            createFieldTextArea({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: 'visibleField', params: { field } }),
                key: `${prefix}producerAddress`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 6 }, wrapperCol: { xs: 24, md: 18 } }),
                label: () => i18n.global.t('model.certificateRequest.address'),
                labelRender: ({ field }) => checkTooltipLabel({ field, labelTitle: field.label(), parentModel: model.refParent, model}),
                inputProp: ({ field }) => (lodash.merge({
                    value: model.producerAddress,
                    'onUpdate:value': value => model.producerAddress = model?.refReportProducerAddressCase?.key === 'U' ? value?.toUpperCase() : value,
                    disabled: viewOnly,
                }, conditionFormChecker({ props, data, executeKey: 'inputPropField', params: { field } }))),
            }),
            {
                visible: () => true,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemRender: () => {
                }
            },
            createFieldSelect({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: 'visibleField', params: { field } }),
                key: `${prefix}refProducerProvince`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 6 }, wrapperCol: { xs: 24, md: 18 } }),
                label: () => i18n.global.t('model.certificateRequest.city'),
                labelRender: ({ field }) => checkTooltipLabel({ field, keySuffix: "name", labelTitle: field.label(), parentModel: model.refParent, model}),
                inputProp: ({ field }) => (lodash.merge({
                    value: model.refProducerProvince,
                    'onUpdate:value': value => model.refProducerProvince = value,
                    disabled: viewOnly,
                    list: callProvince,
                    optLabel: "nameEn",
                    renderLabel: ({ item }) => <div>{model?.refReportProducerAddressCase?.key === 'U' ? `${item.nameEn?.toUpperCase()}` : `${item?.nameEn}`}</div>
                }, conditionFormChecker({ props, data, executeKey: 'inputPropField', params: { field } }))),
                changeLog: { getValue: ({ record, field }) => lodash.get(record, `${field.key}.nameEn`) }
            }),
            createFieldInput({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: 'visibleField', params: { field } }),
                key: `${prefix}producerPostcode`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 6 }, wrapperCol: { xs: 24, md: 18 } }),
                label: () => i18n.global.t('model.certificateRequest.postcode'),
                labelRender: ({ field }) => checkTooltipLabel({ field, labelTitle: field.label(), parentModel: model.refParent, model}),
                inputProp: ({ field }) => (lodash.merge({
                    value: model.producerPostcode || model.refCompany?.refFactoryAddrEn?.postCode  ,
                    'onUpdate:value': value => model.producerPostcode = model?.refReportProducerAddressCase?.key === 'U' ? value?.toUpperCase() : value,
                    disabled: viewOnly,
                }, conditionFormChecker({ props, data, executeKey: 'inputPropField', params: { field } })))
            }),
            createFieldInput({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: 'visibleField', params: { field } }),
                key: `${prefix}producerPhoneNo`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 6 }, wrapperCol: { xs: 24, md: 18 } }),
                label: () => i18n.global.t('model.certificateRequest.producerPhoneNo'),
                labelRender: ({ field }) => checkTooltipLabel({ field, labelTitle: field.label(), parentModel: model.refParent, model}),
                inputProp: ({ field }) => (lodash.merge({
                    value: model.producerPhoneNo,
                    'onUpdate:value': value => model.producerPhoneNo = model?.refReportProducerAddressCase?.key === 'U' ? value?.toUpperCase() : value,
                    disabled: viewOnly,
                }, conditionFormChecker({ props, data, executeKey: 'inputPropField', params: { field } })))
            }),
        ]
    })
}

export const createFieldExporterDetail = ({ props, data, key }) => {
    const { viewOnly } = props
    const { useForm } = data
    const { modelRef } = useForm
    const model = key ? lodash.get(modelRef, key) : modelRef
    const prefix = key ? `${key}.` : ''
    return putField({
        data, fields: [
            createFieldRadioGroup({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}refReportExporterAddressCase`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.certificateRequest.refReportExporterAddressCase"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.refReportExporterAddressCase,
                            "onUpdate:value": value => {
                                model.refReportExporterAddressCase = value
                                formatExporterAddress({modelRef: model, format: value.key})
                            },
                            disabled: viewOnly,
                            list: ({ searchQuery }) => callReportAddressCase({searchQuery}).then(addrCase => (addrCase.filter(c => ["N", "U"].includes(c.key)))),
                            optLabel: "value"
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    ),
                changeLog: { getValue: ({ record, field }) => lodash.get(record, `${field.key}.value`) }
            }),
            {
                visible: () => true,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemRender: () => {
                }
            },
            createFieldInput({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: 'visibleField', params: { field } }),
                key: `${prefix}exporterName`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 6 }, wrapperCol: { xs: 24, md: 18 } }),
                label: () => i18n.global.t('model.certificateRequest.exporterName'),
                labelRender: ({ field }) => checkTooltipLabel({ field, labelTitle: field.label(), parentModel: model.refParent, model}),
                inputProp: ({ field }) => (lodash.merge({
                    value: model.exporterName,
                    'onUpdate:value': value => model.exporterName = model?.refReportExporterAddressCase?.key === 'U' ? value?.toUpperCase() : value,
                    disabled: viewOnly
                }, conditionFormChecker({ props, data, executeKey: 'inputPropField', params: { field } }))),
            }),
            {
                visible: () => true,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemRender: () => {
                }
            },
            createFieldTextArea({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: 'visibleField', params: { field } }),
                key: `${prefix}exporterAddress`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 6 }, wrapperCol: { xs: 24, md: 18 } }),
                label: () => i18n.global.t('model.certificateRequest.address'),
                labelRender: ({ field }) => checkTooltipLabel({ field, labelTitle: field.label(), parentModel: model.refParent, model}),
                inputProp: ({ field }) => (lodash.merge({
                    value: model.exporterAddress,
                    'onUpdate:value': value => model.exporterAddress = model?.refReportExporterAddressCase?.key === 'U' ? value?.toUpperCase() : value,
                    disabled: viewOnly
                }, conditionFormChecker({ props, data, executeKey: 'inputPropField', params: { field } }))),
            }),
            {
                visible: () => true,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemRender: () => {
                }
            },
            createFieldSelect({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: 'visibleField', params: { field } }),
                key: `${prefix}refExporterProvince`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 6 }, wrapperCol: { xs: 24, md: 18 } }),
                label: () => i18n.global.t('model.certificateRequest.city'),
                labelRender: ({ field }) => checkTooltipLabel({ field, keySuffix: "name", labelTitle: field.label(), parentModel: model.refParent, model}),
                inputProp: ({ field }) => (lodash.merge({
                    value: model.refExporterProvince,
                    'onUpdate:value': value => model.refExporterProvince = value,
                    disabled: viewOnly,
                    list: callProvince,
                    optLabel: "nameEn",
                    renderLabel: ({ item }) => <div>{model?.refReportExporterAddressCase?.key === 'U' ? `${item.nameEn?.toUpperCase()}` : `${item?.nameEn}`}</div>
                }, conditionFormChecker({ props, data, executeKey: 'inputPropField', params: { field } }))),
                changeLog: { getValue: ({ record, field }) => lodash.get(record, `${field.key}.nameEn`) }
            }),
            createFieldInput({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: 'visibleField', params: { field } }),
                key: `${prefix}exporterPostcode`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 6 }, wrapperCol: { xs: 24, md: 18 } }),
                label: () => i18n.global.t('model.certificateRequest.postcode'),
                labelRender: ({ field }) => checkTooltipLabel({ field, labelTitle: field.label(), parentModel: model.refParent, model}),
                inputProp: ({ field }) => (lodash.merge({
                    value: model.exporterPostcode,
                    'onUpdate:value': value => model.exporterPostcode = model?.refReportExporterAddressCase?.key === 'U' ? value?.toUpperCase() : value,
                    disabled: viewOnly
                }, conditionFormChecker({ props, data, executeKey: 'inputPropField', params: { field } })))
            }),
            createFieldInput({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: 'visibleField', params: { field } }),
                key: `${prefix}exporterPhoneNo`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 6 }, wrapperCol: { xs: 24, md: 18 } }),
                label: () => i18n.global.t('model.certificateRequest.exporterPhoneNo'),
                labelRender: ({ field }) => checkTooltipLabel({ field, labelTitle: field.label(), parentModel: model.refParent, model}),
                inputProp: ({ field }) => (lodash.merge({
                    value: model.exporterPhoneNo,
                    'onUpdate:value': value => model.exporterPhoneNo = model?.refReportExporterAddressCase?.key === 'U' ? value?.toUpperCase() : value,
                    disabled: viewOnly,
                }, conditionFormChecker({ props, data, executeKey: 'inputPropField', params: { field } })))
            }),
        ]
    })
}

export const createFieldConsigneeDetail = ({ props, data, key }) => {
    const { viewOnly } = props
    const { useForm } = data
    const { modelRef } = useForm
    const model = key ? lodash.get(modelRef, key) : modelRef
    const prefix = key ? `${key}.` : ''
    return putField({
        data, fields: [
            createFieldInput({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: 'visibleField', params: { field } }),
                key: `${prefix}consigneeName`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 6 }, wrapperCol: { xs: 24, md: 18 } }),
                label: () => i18n.global.t('model.certificateRequest.consigneeName'),
                labelRender: ({ field }) => checkTooltipLabel({ field, labelTitle: field.label(), parentModel: model.refParent, model}),
                inputProp: ({ field }) => (lodash.merge({
                    value: model.consigneeName,
                    'onUpdate:value': value => model.consigneeName = value,
                    disabled: viewOnly
                }, conditionFormChecker({ props, data, executeKey: 'inputPropField', params: { field } })))
            }),
            {
                visible: () => true,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemRender: () => {
                }
            },
            createFieldTextArea({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: 'visibleField', params: { field } }),
                key: `${prefix}consigneeAddress`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 6 }, wrapperCol: { xs: 24, md: 18 } }),
                label: () => i18n.global.t('model.certificateRequest.address'),
                labelRender: ({ field }) => checkTooltipLabel({ field, labelTitle: field.label(), parentModel: model.refParent, model}),
                inputProp: ({ field }) => (lodash.merge({
                    value: model.consigneeAddress,
                    'onUpdate:value': value => model.consigneeAddress = value,
                    disabled: viewOnly
                }, conditionFormChecker({ props, data, executeKey: 'inputPropField', params: { field } })))
            }),
            {
                visible: () => true,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemRender: () => {
                }
            },
            createFieldInput({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: 'visibleField', params: { field } }),
                key: `${prefix}consigneeCity`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 6 }, wrapperCol: { xs: 24, md: 18 } }),
                label: () => i18n.global.t('model.certificateRequest.city'),
                labelRender: ({ field }) => checkTooltipLabel({ field, labelTitle: field.label(), parentModel: model.refParent, model}),
                inputProp: ({ field }) => (lodash.merge({
                    value: model.consigneeCity,
                    'onUpdate:value': value => model.consigneeCity = value,
                    disabled: viewOnly,
                }, conditionFormChecker({ props, data, executeKey: 'inputPropField', params: { field } }))),
            }),
            createFieldInput({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: 'visibleField', params: { field } }),
                key: `${prefix}consigneePostcode`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 6 }, wrapperCol: { xs: 24, md: 18 } }),
                label: () => i18n.global.t('model.certificateRequest.postcode'),
                labelRender: ({ field }) => checkTooltipLabel({ field, labelTitle: field.label(), parentModel: model.refParent, model}),
                inputProp: ({ field }) => (lodash.merge({
                    value: model.consigneePostcode,
                    'onUpdate:value': value => model.consigneePostcode = value,
                    disabled: viewOnly
                }, conditionFormChecker({ props, data, executeKey: 'inputPropField', params: { field } })))
            }),
            createFieldInput({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: 'visibleField', params: { field } }),
                key: `${prefix}consigneePhoneNo`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 6 }, wrapperCol: { xs: 24, md: 18 } }),
                label: () => i18n.global.t('model.certificateRequest.consigneePhoneNo'),
                labelRender: ({ field }) => checkTooltipLabel({ field, labelTitle: field.label(), parentModel: model.refParent, model}),
                inputProp: ({ field }) => (lodash.merge({
                    value: model.consigneePhoneNo,
                    'onUpdate:value': value => model.consigneePhoneNo = value,
                    disabled: viewOnly,
                }, conditionFormChecker({ props, data, executeKey: 'inputPropField', params: { field } })))
            }),
        ]
    })
}

export const createFieldProductDetail = ({ props, data,/* refs,*/ key}) => {
    const { viewOnly, menuContext } = props
    const { useForm } = data
    const { modelRef } = useForm
    const model = key ? lodash.get(modelRef, key) : modelRef
    const prefix = key ? `${key}.` : ''
    const visibleEdit = (has({ menuContext, key: 'forCertificateApprover' }) || has({ menuContext: menuContext, key: 'forCertificateSigner' })) && model.isTmp ? false : true
    return putField({
        data, fields: [
            createFieldTextArea({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: 'visibleField', params: { field } }),
                key: `${prefix}commodityName`,
                colProp: () => ({ xs: 24, md: 16 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 6 }, wrapperCol: { xs: 24, md: 18 } }),
                label: () => i18n.global.t('model.certificateRequest.commodityName'),
                labelRender: ({ field }) => checkTooltipLabel({ field, labelTitle: field.label(), parentModel: model.refParent, model}),
                inputProp: ({ field }) => (lodash.merge({
                    value: model.commodityName,
                    'onUpdate:value': value => model.commodityName = value,
                    disabled: viewOnly
                }, conditionFormChecker({ props, data, executeKey: 'inputPropField', params: { field } }))),
            }),
            {
                visible: () => true,
                colProp: () => ({ xs: 24, md: 24 }),
                formItemRender: () => {
                    return () => <div><Divider class="my-3" orientation="left"></Divider></div>
                }
            },
            {
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: 'visibleField', params: { field } }),
                colProp: () => ({ xs: 24, md: 24 }),
                formItemRender: () => {
                    /*return <div id={"divAquaticScientificName"}>
                    <CertificateAquaticScientificNameList
                        id={"aquaticScientificNames"}
                        menuContext={menuContext}
                        viewOnly={viewOnly}
                        useForm={useForm}
                        itemsKey="aquaticScientificNames"
                        isTmp={model.isTmp}
                        visibleSearch={ false }
                        visibleEdit={visibleEdit}
                    ></CertificateAquaticScientificNameList>
                </div>*/
                    return (
                        <CardBorder title={i18n.global.t("views.certificate.certificateRequest.aquaticScientificName.title")} id={"divAquaticScientificName"} >
                            <CertificateAquaticScientificNameList
                                id={"aquaticScientificNames"}
                                menuContext={menuContext}
                                viewOnly={viewOnly}
                                dataProp={data}
                                itemsKey="aquaticScientificNames"
                                isTmp={model.isTmp}
                                visibleSearch={ false }
                                visibleEdit={visibleEdit}
                            ></CertificateAquaticScientificNameList>
                        </CardBorder>
                    );
                }
            },
            {
                visible: () => model.isAllModels,
                colProp: () => ({ xs: 24, md: 24 }),
                formItemRender: () => {
                    return () => <div><Divider class="my-3" orientation="left"></Divider></div>
                }
            },
            {
                visible: () => conditionFormChecker({ props, data, executeKey: 'visibleSection', params: { sectionKey: 'packagingSizeAllModels' } }),
                key: `${prefix}packagingSizeAllModels`,
                colProp: () => ({ xs: 24, md: 24 }),
                formItemRender: () => {
                    const componentProp = lodash.merge({
                        menuContext,
                        viewOnly: viewOnly,
                        dataProp: data,
                        itemsKey: 'certificateProducts',
                        isTmp: model.isTmp,
                        canAddProduct: false
                        // ref: e => lodash.set(refs, 'certificateProductList', e),
                    }, conditionFormChecker({ props, data, executeKey: 'componentProp', params: { sectionKey: 'packagingSizeAllModels' } }))
                    /*return <div><CertificateProductList {...componentProp} ></CertificateProductList></div>*/

                    return (
                        <CardBorder title={i18n.global.t('model.certificateRequest.labels.packaging')} >
                            <CertificateProductList {...componentProp} ></CertificateProductList>
                        </CardBorder>
                    );
                }
            },
            createFieldTextArea({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: 'visibleField', params: { field } }),
                key: `${prefix}packagingSize`,
                colProp: () => ({ xs: 24, md: 16 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 6 }, wrapperCol: { xs: 24, md: 18 } }),
                label: () => i18n.global.t('model.certificateRequest.packagingSize'),
                labelRender: ({ field }) => checkTooltipLabel({ field, labelTitle: field.label(), parentModel: model.refParent, model}),
                inputProp: ({ field }) => (lodash.merge({
                    value: model.packagingSize,
                    'onUpdate:value': value => model.packagingSize = value,
                    disabled: viewOnly,
                }, conditionFormChecker({ props, data, executeKey: 'inputPropField', params: { field } }))),
            }),
            {
                visible: () => true,
                colProp: () => ({ xs: 24, md: 24 }),
                formItemRender: () => {
                }
            },
            createFieldInputNumber({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: 'visibleField', params: { field } }),
                key: `${prefix}qty`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t('model.certificateRequest.qty'),
                labelRender: ({ field }) => checkTooltipLabel({ field, labelTitle: field.label(), parentModel: model.refParent, model}),
                inputProp: ({ field }) => (lodash.merge({
                    value: model.qty,
                    'onUpdate:value': value => model.qty = value,
                    disabled: viewOnly,
                    allowPrecision: true,
                    maxPrecision: 3,
                    autoPrecision: false,
                    comma: true
                }, conditionFormChecker({ props, data, executeKey: 'inputPropField', params: { field } })))
            }),
            createFieldSelect({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: 'visibleField', params: { field } }),
                key: `${prefix}refExportAmountUnit`,
                colProp: () => ({ xs: 24, md: 4 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 6 }, wrapperCol: { xs: 24, md: 18 } }),
                label: () => "",
                labelRender: ({ field }) => checkTooltipLabel({ field, keySuffix: "value", labelTitle: field.label(), parentModel: model.refParent, model}),
                inputProp: ({ field }) => (lodash.merge({
                    value: model.refExportAmountUnit,
                    'onUpdate:value': value => model.refExportAmountUnit = value,
                    disabled: viewOnly,
                    list: callExportAmountUnit,
                    optKey: "key",
                    optLabel: "value",
                }, conditionFormChecker({ props, data, executeKey: 'inputPropField', params: { field } }))),
                changeLog: { getValue: ({ record, field }) => lodash.get(record, `${field.key}.value`) }
            }),
            createFieldInputNumber({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: 'visibleField', params: { field } }),
                key: `${prefix}netWeight`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t('model.certificateRequest.netWeight'),
                labelRender: ({ field }) => checkTooltipLabel({ field, labelTitle: field.label(), parentModel: model.refParent, model}),
                inputProp: ({ field }) => (lodash.merge({
                    value: model.netWeight,
                    'onUpdate:value': value => model.netWeight = value,
                    disabled: viewOnly,
                    comma: true,
                    allowPrecision: true,
                    autoPrecision: false,
                    maxPrecision: 3,
                }, conditionFormChecker({ props, data, executeKey: 'inputPropField', params: { field } })))
            }),
            {
                visible: () => true,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemRender: () => {
                        return () => <div><p>Kgs.</p></div>
                }
            },
            createFieldInputNumber({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: 'visibleField', params: { field } }),
                key: `${prefix}grossWeight`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t('model.certificateRequest.grossWeight'),
                labelRender: ({ field }) => checkTooltipLabel({ field, labelTitle: field.label(), parentModel: model.refParent, model}),
                inputProp: ({ field }) => (lodash.merge({
                    value: model.grossWeight,
                    'onUpdate:value': value => model.grossWeight = value,
                    disabled: viewOnly,
                    comma: true,
                    allowPrecision: true,
                    autoPrecision: false,
                    maxPrecision: 3,
                }, conditionFormChecker({ props, data, executeKey: 'inputPropField', params: { field } })))
            }),
            {
                visible: () => true,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemRender: () => {
                    return () => <div><p>Kgs.</p></div>
                }
            },
            createFieldTextArea({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: 'visibleField', params: { field } }),
                key: `${prefix}productCodeNo`,
                colProp: () => ({ xs: 24, md: 16 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 6 }, wrapperCol: { xs: 24, md: 18 } }),
                label: () => i18n.global.t('model.certificateRequest.productCodeNo'),
                labelRender: ({ field }) => checkTooltipLabel({ field, labelTitle: field.label(), parentModel: model.refParent, model}),
                inputProp: ({ field }) => (lodash.merge({
                    value: model.productCodeNo,
                    'onUpdate:value': value => model.productCodeNo = value,
                    disabled: viewOnly
                }, conditionFormChecker({ props, data, executeKey: 'inputPropField', params: { field } }))),
            }),
        ]
    })
}

export const createFieldTransportDetail = ({ props, data, key}) => {
    const { viewOnly } = props
    const { useForm } = data
    const { modelRef } = useForm
    const model = key ? lodash.get(modelRef, key) : modelRef
    const prefix = key ? `${key}.` : ''
    return putField({
        data, fields: [
            createFieldRadioGroup({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: 'visibleField', params: { field } }),
                key: `${prefix}refTransportMode`,
                colProp: () => ({ xs: 24, md: 18 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 6 }, wrapperCol: { xs: 24, md: 18 } }),
                label: () => i18n.global.t('model.certificateRequest.refTransportMode'),
                labelRender: ({ field }) => checkTooltipLabel({ field, keySuffix: "value", labelTitle: field.label(), parentModel: model.refParent, model}),
                inputProp: ({ field }) => (lodash.merge({
                    value: model.refTransportMode,
                    'onUpdate:value': value => model.refTransportMode = value,
                    disabled: viewOnly,
                    list: callTransportMode,
                    optKey: "key",
                    optLabel: "valueEn",
                }, conditionFormChecker({ props, data, executeKey: 'inputPropField', params: { field } }))),
                changeLog: { getValue: ({ record, field }) => lodash.get(record, `${field.key}.valueEn`) }
            }),
            createFieldInput({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: 'visibleField', params: { field } }),
                key: `${prefix}vehicleName`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 10 }, wrapperCol: { xs: 24, md: 14 } }),
                label: () => i18n.global.t('model.certificateRequest.vehicleName'),
                labelRender: ({ field }) => checkTooltipLabel({ field, labelTitle: field.label(), parentModel: model.refParent, model}),
                inputProp: ({ field }) => (lodash.merge({
                    value: model.vehicleName,
                    'onUpdate:value': value => model.vehicleName = value,
                    disabled: viewOnly
                }, conditionFormChecker({ props, data, executeKey: 'inputPropField', params: { field } })))
            }),
            createFieldInput({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: 'visibleField', params: { field } }),
                key: `${prefix}referenceDocNo`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 10 }, wrapperCol: { xs: 24, md: 14 } }),
                label: () => i18n.global.t('model.certificateRequest.referenceDocNo'),
                labelRender: ({ field }) => checkTooltipLabel({ field, labelTitle: field.label(), parentModel: model.refParent, model}),
                inputProp: ({ field }) => (lodash.merge({
                    value: model.referenceDocNo,
                    'onUpdate:value': value => model.referenceDocNo = value,
                    disabled: viewOnly
                }, conditionFormChecker({ props, data, executeKey: 'inputPropField', params: { field } })))
            }),
            createFieldInput({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: 'visibleField', params: { field } }),
                key: `${prefix}sourcePortCity`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 10 }, wrapperCol: { xs: 24, md: 14 } }),
                label: () => i18n.global.t('model.certificateRequest.sourcePort'),
                labelRender: ({ field }) => checkTooltipLabel({ field, labelTitle: field.label(), parentModel: model.refParent, model}),
                inputProp: ({ field }) => (lodash.merge({
                    value: model.sourcePortCity,
                    'onUpdate:value': value => model.sourcePortCity = value,
                    disabled: viewOnly
                }, conditionFormChecker({ props, data, executeKey: 'inputPropField', params: { field } })))
            }),
            createFieldSelect({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: 'visibleField', params: { field } }),
                key: `${prefix}refSourcePortCountry`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ wrapperCol: { xs: 24, md: 6 } }),
                label: () => "",
                labelRender: ({ field }) => checkTooltipLabel({ field, keySuffix: "nameEn", labelTitle: field.label(), parentModel: model.refParent, model}),
                inputProp: ({ field }) => (lodash.merge({
                    value: model.refSourcePortCountry,
                    'onUpdate:value': value => model.refSourcePortCountry = value,
                    disabled: true,
                    list: ({ searchQuery }) => callCountry({ searchQuery }).then(countries => countries.filter(d => ['Thailand'].includes(d.nameEn))),
                    optKey: "id",
                    optLabel: "nameEn",
                }, conditionFormChecker({ props, data, executeKey: 'inputPropField', params: { field } }))),
                changeLog: { getValue: ({ record, field }) => lodash.get(record, `${field.key}.nameEn`) }
            }),
            createFieldInput({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: 'visibleField', params: { field } }),
                key: `${prefix}destinationPort`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 10 }, wrapperCol: { xs: 24, md: 14 } }),
                label: () => i18n.global.t('model.certificateRequest.destinationPort'),
                labelRender: ({ field }) => checkTooltipLabel({ field, labelTitle: field.label(), parentModel: model.refParent, model}),
                inputProp: ({ field }) => (lodash.merge({
                    value: model.destinationPort,
                    'onUpdate:value': value => model.destinationPort = value,
                    disabled: viewOnly
                }, conditionFormChecker({ props, data, executeKey: 'inputPropField', params: { field } })))
            }),
            createFieldSelect({
                key: `${prefix}refDestinationPortCountry`,
                visible: ({ field }) =>  conditionFormChecker({ props, data, executeKey: 'visibleField', params: { field } }),
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ wrapperCol: { xs: 24, md: 6 } }),
                label: () => "",
                labelRender: ({ field }) => checkTooltipLabel({ field, keySuffix: "nameEn", labelTitle: field.label(), parentModel: model.refParent, model}),
                inputProp: ({ field }) => (lodash.merge({
                    value: model.refExportCountry,
                    'onUpdate:value': value => model.refExportCountry = value,
                    disabled: true,
                    list:  ({ searchQuery }) => {
                        const where =  [
                            { name: 'isSpecial', operator: '=', value: false },
                            { name: 'haveChildren', operator: '=', value: false },
                        ]
                        return Promise.all([callCompanyCountries({ refCompanyId: modelRef.refCompany?.id }), store.dispatch('resource/v1/master/country/cacheFindAll', { where, options: { force: true }})])
                            .then(arr => {
                                const allComapnyCountry = arr[0].flatMap(d => d.children.length > 0 ? d.children : [d])
                                const allComapnyCountryId = allComapnyCountry.map(c => c.id)
                                const allIsNotSpecialCountry = arr[1].filter(d => !allComapnyCountryId.includes(d.id))
                                const listExportCountries = [...new Set([...allComapnyCountry,...allIsNotSpecialCountry])]

                                return filter({
                                    list: listExportCountries,
                                    where: [
                                        { name: "alpha", type: "String", isNot: true, operator: 'in', value: ['THA', 'DOF'] },
                                        { openBucket: true, name: "nameEn", type: "String", operator: 'like', value: searchQuery },
                                        { closeBucket: true, logic: 'OR', name: "nameTh", type: 'String', operator: 'like', value: searchQuery }
                                    ],
                                    sort: [{ name: "nameEn", type: "ASC" }] })
                            })
                    },
                    optKey: "id",
                    optLabel: "nameEn",
                }, conditionFormChecker({ props, data, executeKey: 'inputPropField', params: { field } }))),
                changeLog: { getValue: ({ record, field }) => lodash.get(record, `${field.key}.nameEn`) }
            }),
            createFieldRadioGroup({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: 'visibleField', params: { field } }),
                key: `${prefix}refIntransitMethod`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 10 }, wrapperCol: { xs: 24, md: 14 } }),
                label: () => i18n.global.t('model.certificateRequest.refIntransitMethod'),
                labelRender: ({ field }) => checkTooltipLabel({ field, keySuffix: "value", labelTitle: field.label(), parentModel: model.refParent, model}),
                inputProp: ({ field }) => (lodash.merge({
                    value: model.refIntransitMethod,
                    'onUpdate:value': value => model.refIntransitMethod = value,
                    disabled: viewOnly,
                    list: callIntransitMethod,
                    optKey: "key",
                    optLabel: "valueEn",
                }, conditionFormChecker({ props, data, executeKey: 'inputPropField', params: { field } }))),
                changeLog: { getValue: ({ record, field }) => lodash.get(record, `${field.key}.valueEn`) }
            }),
            {
                visible: () => true,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemRender: () => {
                    return () => <div></div>
                }
            },
            createFieldInput({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: 'visibleField', params: { field } }),
                key: `${prefix}destinationViaPort`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 10 }, wrapperCol: { xs: 24, md: 14 } }),
                label: () => i18n.global.t('model.certificateRequest.destinationViaPort'),
                labelRender: ({ field }) => checkTooltipLabel({ field, labelTitle: field.label(), parentModel: model.refParent, model}),
                inputProp: ({ field }) => (lodash.merge({
                    value: model.destinationViaPort,
                    'onUpdate:value': value => model.destinationViaPort = value,
                    disabled: viewOnly
                }, conditionFormChecker({ props, data, executeKey: 'inputPropField', params: { field } }))),
            }),
            createFieldSelect({
                key: `${prefix}refDestinationViaCountry`,
                visible: ({ field }) =>  conditionFormChecker({ props, data, executeKey: 'visibleField', params: { field } }),
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 10 }, wrapperCol: { xs: 24, md: 14 } }),
                label: () => i18n.global.t('model.certificateRequest.country'),
                labelRender: ({ field }) => checkTooltipLabel({ field, keySuffix: "nameEn", labelTitle: field.label(), parentModel: model.refParent, model}),
                inputProp: ({ field }) => (lodash.merge({
                    value: model.refDestinationViaCountry,
                    'onUpdate:value': value => model.refDestinationViaCountry = value,
                    disabled: viewOnly,
                    list:  ({ searchQuery }) => {
                        const where =  [
                            { name: 'haveChildren', operator: '=', value: false },
                        ]
                        return Promise.all([store.dispatch('resource/v1/master/country/cacheFindAll', { where, options: { force: true }})])
                            .then(arr => {
                                return filter({
                                    list: arr[0],
                                    where: [
                                        { name: "alpha", type: "String", isNot: true, operator: 'in', value: ['THA', 'DOF'] },
                                        { openBucket: true, name: "nameEn", type: "String", operator: 'like', value: searchQuery },
                                        { closeBucket: true, logic: 'OR', name: "nameTh", type: 'String', operator: 'like', value: searchQuery }
                                    ],
                                    sort: [{ name: "nameEn", type: "ASC" }] })
                            })
                    },
                    optKey: "id",
                    optLabel: "nameEn",
                }, conditionFormChecker({ props, data, executeKey: 'inputPropField', params: { field } }))),
                changeLog: { getValue: ({ record, field }) => lodash.get(record, `${field.key}.nameEn`) }
            }),
            createFieldDate({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: 'visibleField', params: { field } }),
                key: `${prefix}loadingDate`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 10 }, wrapperCol: { xs: 24, md: 14 } }),
                label: () => i18n.global.t('model.certificateRequest.loadingDate'),
                labelRender: ({ field }) => checkTooltipLabel({ field, labelTitle: field.label(), parentModel: model.refParent, model}),
                inputProp: ({ field }) => (lodash.merge({
                    value: model.loadingDate,
                    'onUpdate:value': value => {
                        // model.certificateApprovalDate =
                        //     (has({ menuContext, key: 'forCertificateApprover' })
                        //     || has({ menuContext: menuContext, key: 'forCertificateSigner' })) ? value : null
                        return model.loadingDate = value
                    },
                    disabled: viewOnly,
                    locale: 'en',
                }, conditionFormChecker({ props, data, executeKey: 'inputPropField', params: { field } })))
            }),
            {
                visible: () => true,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemRender: () => {
                }
            },
            createFieldDate({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: 'visibleField', params: { field } }),
                key: `${prefix}shipmentDate`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 10 }, wrapperCol: { xs: 24, md: 14 } }),
                label: () => i18n.global.t('model.certificateRequest.shipmentDate'),
                labelRender: ({ field }) => checkTooltipLabel({ field, labelTitle: field.label(), parentModel: model.refParent, model}),
                inputProp: ({ field }) => (lodash.merge({
                    value: model.shipmentDate,
                    'onUpdate:value': value => (model.shipmentDate = value),
                    disabled: viewOnly,
                    locale: 'en',
                }, conditionFormChecker({ props, data, executeKey: 'inputPropField', params: { field } })))
            }),
            {
                visible: () => true,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemRender: () => {
                }
            },
            createFieldInput({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: 'visibleField', params: { field } }),
                key: `${prefix}containerNo`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 10 }, wrapperCol: { xs: 24, md: 14 } }),
                label: () => i18n.global.t('model.certificateRequest.containerNo'),
                labelRender: ({ field }) => checkTooltipLabel({ field, labelTitle: field.label(), parentModel: model.refParent, model}),
                inputProp: ({ field }) => (lodash.merge({
                    value: model.containerNo,
                    'onUpdate:value': value => model.containerNo = value,
                    disabled: viewOnly
                }, conditionFormChecker({ props, data, executeKey: 'inputPropField', params: { field } })))
            }),
            {
                visible: () => true,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemRender: () => {
                }
            },
            createFieldInput({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: 'visibleField', params: { field } }),
                key: `${prefix}sealNo`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 10 }, wrapperCol: { xs: 24, md: 14 } }),
                label: () => i18n.global.t('model.certificateRequest.sealNo'),
                labelRender: ({ field }) => checkTooltipLabel({ field, labelTitle: field.label(), parentModel: model.refParent, model}),
                inputProp: ({ field }) => (lodash.merge({
                    value: model.sealNo,
                    'onUpdate:value': value => model.sealNo = value,
                    disabled: viewOnly
                }, conditionFormChecker({ props, data, executeKey: 'inputPropField', params: { field } })))            }),
            {
                visible: () => true,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemRender: () => {
                }
            },
            createFieldRadioGroup({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: 'visibleField', params: { field } }),
                key: `${prefix}refTransportTemperature`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 10 }, wrapperCol: { xs: 24, md: 14 } }),
                label: () => i18n.global.t('model.certificateRequest.refTransportTemperature'),
                labelRender: ({ field }) => checkTooltipLabel({ field, keySuffix: "value", labelTitle: field.label(), parentModel: model.refParent, model}),
                inputProp: ({ field }) => (lodash.merge({
                    value: model.refTransportTemperature,
                    'onUpdate:value': value => model.refTransportTemperature = value,
                    disabled: viewOnly,
                    list: callTransportTemperatureType,
                    optKey: "key",
                    optLabel: "valueEn",
                    type: "vertical",
                }, conditionFormChecker({ props, data, executeKey: 'inputPropField', params: { field } }))),
                changeLog: { getValue: ({ record, field }) => lodash.get(record, `${field.key}.valueEn`) }
            }),
            {
                visible: () => true,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemRender: () => {
                }
            },
            createFieldInput({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: 'visibleField', params: { field } }),
                key: `${prefix}temperatureValue`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 10 }, wrapperCol: { xs: 24, md: 14 } }),
                label: () => "",
                labelRender: ({ field }) => checkTooltipLabel({ field, labelTitle: field.label(), parentModel: model.refParent, model}),
                inputProp: ({ field }) => (lodash.merge({
                    value: model.temperatureValue,
                    'onUpdate:value': value => model.temperatureValue = value,
                    disabled: viewOnly,
                    suffix: 'Degree Celsius'
                }, conditionFormChecker({ props, data, executeKey: 'inputPropField', params: { field } })))
            }),
            /*createFieldInputNumber({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: 'visibleField', params: { field } }),
                key: `${prefix}temperatureValue`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 10 }, wrapperCol: { xs: 24, md: 14 } }),
                label: () => "",
                labelRender: ({ field }) => checkTooltipLabel({ field, labelTitle: field.label(), parentModel: model.refParent, model}),
                inputProp: ({ field }) => (lodash.merge({
                    value: model.temperatureValue,
                    'onUpdate:value': value => model.temperatureValue = value,
                    disabled: viewOnly,
                    comma: false,
                    allowMinus: true,
                    allowPrecision: true,
                    autoPrecision: false,
                    suffix: 'Degree Celsius'
                }, conditionFormChecker({ props, data, executeKey: 'inputPropField', params: { field } }))),
            }),*/
            {
                visible: () => true,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemRender: () => {
                }
            },
            createFieldInput({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: 'visibleField', params: { field } }),
                key: `${prefix}shippingMask`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 10 }, wrapperCol: { xs: 24, md: 14 } }),
                label: () => i18n.global.t('model.certificateRequest.shippingMark'),
                labelRender: ({ field }) => checkTooltipLabel({ field, labelTitle: field.label(), parentModel: model.refParent, model}),
                inputProp: ({ field }) => (lodash.merge({
                    value: model.shippingMask,
                    'onUpdate:value': value => model.shippingMask = value,
                    disabled: viewOnly
                }, conditionFormChecker({ props, data, executeKey: 'inputPropField', params: { field } })))
            }),
            {
                visible: () => true,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemRender: () => {
                }
            },
            // createFieldInputNumber({
            //     visible: ({ field }) => conditionFormChecker({ props, data, executeKey: 'visibleField', params: { field } }),
            //     key: `${prefix}fob`,
            //     colProp: () => ({ xs: 24, md: 12 }),
            //     formItemProp: () => ({ labelCol: { xs: 24, md: 10 }, wrapperCol: { xs: 24, md: 14 } }),
            //     label: () => i18n.global.t('model.certificateRequest.fob'),
            //     labelRender: ({ field }) => checkTooltipLabel({ field, labelTitle: field.label(), parentModel: model.refParent, model}),
            //     inputProp: ({ field }) => (lodash.merge({
            //         value: model.fob,
            //         'onUpdate:value': value => model.fob = value,
            //         disabled: viewOnly,
            //         comma: true,
            //         allowPrecision: true,
            //         autoPrecision: false,
            //         suffix: '$ (ดอลลาร์)'
            //     }, conditionFormChecker({ props, data, executeKey: 'inputPropField', params: { field } })))
            // }),
            // {
            //     visible: () => true,
            //     colProp: () => ({ xs: 24, md: 12 }),
            //     formItemRender: () => {
            //     }
            // },
        ]
    })
}

export const createFieldCertificateRequestAttachment = ({ props, data, key, isLoading }) => {
    const { viewOnly, menuContext } = props
    const { useForm } = data
    const prefix = key ? `${key}.` : ''
    return putField({
        data, fields: [
            {
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: 'visibleField', params: { field } }),
                colProp: () => ({ xs: 24, md: 24 }),
                formItemRender: () => { return () => <div>
                    <AttachmentList
                        menuContext={menuContext}
                        viewOnly={viewOnly || data.disabledList}
                        rowProp={data.rowProp}
                        useForm={useForm}
                        parent={data.useForm.modelRef}
                        group="Attachment"
                        fetchCriteria={data.attachments?.fetchCriteria}
                        skeleton={isLoading.value}
                        visibleSearch={false}
                    ></AttachmentList>
                </div> }
            },
            {
                key: `${prefix}certificateRequestAttachment`,
                label: () => i18n.global.t('model.companyAttachment.modelName'),
                changeLog: { getValueChildren: ({ record }) => record.refCertificateRequestAttachment?.value }
            }
        ]
    })
}

export const createFieldMoreInformation = ({  props, data, key }) => {
    const { viewOnly, menuContext } = props
    const { useForm } = data
    const { modelRef } = useForm
    const model = key ? lodash.get(modelRef, key) : modelRef
    const prefix = key ? `${key}.` : ''
    const visibleEdit = (has({ menuContext, key: 'forCertificateApprover' }) || has({ menuContext: menuContext, key: 'forCertificateSigner' })) && model.isTmp ? false : true
    return putField({
        data, fields: [
            createFieldInput({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: 'visibleField', params: { field } }),
                key: `${prefix}typeOfTreatment`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t('model.certificateRequest.additionalInformation.typeOfTreatment'),
                labelRender: ({ field }) => checkTooltipLabel({ field, labelTitle: field.label(), parentModel: model.refParent, model}),
                inputProp: ({ field }) => (lodash.merge({
                    value: model.typeOfTreatment,
                    'onUpdate:value': value => model.typeOfTreatment = value,
                    disabled: viewOnly
                }, conditionFormChecker({ props, data, executeKey: 'inputPropField', params: { field } })))
            }),
            {
                key: `${prefix}typeOfTreatmentHiddenBlock`,
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: 'visibleField', params: { field } }),
                colProp: () => ({ xs: 24, md: 12 }),
                formItemRender: () => {
                }
            },
            createFieldInput({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: 'visibleField', params: { field } }),
                key: `${prefix}hsCode`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t('model.certificateRequest.additionalInformation.hsCode'),
                labelRender: ({ field }) => checkTooltipLabel({ field, labelTitle: field.label(), parentModel: model.refParent, model}),
                inputProp: ({ field }) => (lodash.merge({
                    value: model.hsCode,
                    'onUpdate:value': value => model.hsCode = value,
                    disabled: viewOnly
                }, conditionFormChecker({ props, data, executeKey: 'inputPropField', params: { field } })))
            }),
            {
                key: `${prefix}hsCodeHiddenBlock`,
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: 'visibleField', params: { field } }),
                colProp: () => ({ xs: 24, md: 12 }),
                formItemRender: () => {
                }
            },
            createFieldRadioGroup({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: 'visibleField', params: { field } }),
                key: `${prefix}refHumanConsumption`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t('model.certificateRequest.additionalInformation.refHumanConsumption'),
                labelRender: ({ field }) => checkTooltipLabel({ field, keySuffix: "value", labelTitle: field.label(), parentModel: model.refParent, model}),
                inputProp: ({ field }) => (lodash.merge({
                    value: model.refHumanConsumption,
                    'onUpdate:value': value => model.refHumanConsumption = value,
                    disabled: viewOnly,
                    list: callHumanConsumption,
                    optKey: "key",
                    optLabel: "value",
                    type: "vertical",
                }, conditionFormChecker({ props, data, executeKey: 'inputPropField', params: { field } }))),
                changeLog: { getValue: ({ record, field }) => lodash.get(record, `${field.key}.value`) }
            }),
            {
                key: `${prefix}refHumanConsumptionHiddenBlock`,
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: 'visibleField', params: { field } }),
                colProp: () => ({ xs: 24, md: 12 }),
                formItemRender: () => {
                }
            },
            createFieldTextArea({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: 'visibleField', params: { field } }),
                key: `${prefix}manufacturingDate`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t('model.certificateRequest.additionalInformation.manufacturingDate'),
                labelRender: ({ field }) => checkTooltipLabel({ field, labelTitle: field.label(), parentModel: model.refParent, model}),
                inputProp: ({ field }) => (lodash.merge({
                    value: model.manufacturingDate,
                    'onUpdate:value': value => model.manufacturingDate = value,
                    disabled: viewOnly
                }, conditionFormChecker({ props, data, executeKey: 'inputPropField', params: { field } })))
            }),
            {
                key: `${prefix}manufacturingDateHiddenBlock`,
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: 'visibleField', params: { field } }),
                colProp: () => ({ xs: 24, md: 12 }),
                formItemRender: () => {
                }
            },
            createFieldDate({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: 'visibleField', params: { field } }),
                key: `${prefix}expiredDate`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t('model.certificateRequest.additionalInformation.expiredDate'),
                labelRender: ({ field }) => checkTooltipLabel({ field, labelTitle: field.label(), parentModel: model.refParent, model}),
                inputProp: ({ field }) => (lodash.merge({
                    value: model.expiredDate,
                    disabled: viewOnly,
                    locale: 'en',
                    'onUpdate:value': value => (model.expiredDate = value)
                }, conditionFormChecker({ props, data, executeKey: 'inputPropField', params: { field } }))),
            }),
            {
                key: `${prefix}expiredDateHiddenBlock`,
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: 'visibleField', params: { field } }),
                colProp: () => ({ xs: 24, md: 12 }),
                formItemRender: () => {
                }
            },
            createFieldInput({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: 'visibleField', params: { field } }),
                key: `${prefix}healthCertificateNo`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t('model.certificateRequest.additionalInformation.healthCertificateNo'),
                labelRender: ({ field }) => checkTooltipLabel({ field, labelTitle: field.label(), parentModel: model.refParent, model}),
                inputProp: ({ field }) => (lodash.merge({
                    value: model.healthCertificateNo,
                    'onUpdate:value': value => model.healthCertificateNo = value,
                    disabled: viewOnly
                }, conditionFormChecker({ props, data, executeKey: 'inputPropField', params: { field } })))
            }),
            createFieldDate({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: 'visibleField', params: { field } }),
                key: `${prefix}healthCertificateDate`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t('model.certificateRequest.additionalInformation.healthCertificateDate'),
                labelRender: ({ field }) => checkTooltipLabel({ field, labelTitle: field.label(), parentModel: model.refParent, model}),
                inputProp: ({ field }) => (lodash.merge({
                    value: model.healthCertificateDate,
                    disabled: viewOnly,
                    locale: 'en',
                    'onUpdate:value': value => (model.healthCertificateDate = value)
                }, conditionFormChecker({ props, data, executeKey: 'inputPropField', params: { field } }))),
            }),
            createFieldSelect({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: 'visibleField', params: { field } }),
                key: `${prefix}refFromCountryOfOrigin`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t('model.certificateRequest.additionalInformation.fromCountryOfOrigin'),
                labelRender: ({ field }) => checkTooltipLabel({ field, keySuffix: "nameTh", labelTitle: field.label(), parentModel: model.refParent, model}),
                inputProp: ({ field }) => (lodash.merge({
                    value: model.refFromCountryOfOrigin,
                    'onUpdate:value': value => model.refFromCountryOfOrigin = value,
                    disabled: viewOnly,
                    list:  ({ searchQuery }) => {
                        const where =  [
                            { name: 'haveChildren', operator: '=', value: false },
                        ]
                        return Promise.all([store.dispatch('resource/v1/master/country/cacheFindAll', { where, options: { force: true }})])
                            .then(arr => {
                                return filter({
                                    list: arr[0],
                                    where: [
                                        { name: "alpha", type: "String", isNot: true, operator: 'in', value: ['THA', 'DOF'] },
                                        { openBucket: true, name: "nameEn", type: "String", operator: 'like', value: searchQuery },
                                        { closeBucket: true, logic: 'OR', name: "nameTh", type: 'String', operator: 'like', value: searchQuery }
                                    ],
                                    sort: [{ name: "nameEn", type: "ASC" }] })
                            })
                    },
                    optKey: "id",
                    optLabel: "nameEn",
                }, conditionFormChecker({ props, data, executeKey: 'inputPropField', params: { field } }))),
                changeLog: { getValue: ({ record, field }) => lodash.get(record, `${field.key}.nameEn`) }
            }),
            {
                key: `${prefix}refFromCountryOfOriginHiddenBlock`,
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: 'visibleField', params: { field } }),
                colProp: () => ({ xs: 24, md: 12 }),
                formItemRender: () => {
                }
            },
            // createFieldCheckbox({
            //     visible: ({ field }) => conditionFormChecker({ props, data, executeKey: 'visibleField', params: { field } }),
            //     key: `${prefix}isAquaculture`,
            //     colProp: () => ({ xs: 24, md: 8 }),
            //     formItemProp: () => ({ labelCol: { xs: 24, md: 12 }, wrapperCol: { xs: 24, md: 12 } }),
            //     label: () => i18n.global.t('model.certificateRequest.additionalInformation.refProductMode'),
            //     labelRender: ({ field }) => checkTooltipLabel({ field, labelTitle: field.label(), parentModel: model.refParent, model}),
            //     inputProp: ({ field }) => (lodash.merge({
            //         checked: model.isAquaculture,
            //         'onUpdate:checked': checked => {
            //             model.isAquaculture = checked
            //             let key = model.isAquaculture ? 'Yes' : 'No'
            //             store.dispatch('resource/v1/master/lookup/cacheFindAllByGroup', { group: 'IS_AQUACULTURE', key, keyOperator: '=' }).then(list => {
            //                 model.refIsAquaculture = list[0]
            //             })
            //             model.aquacultureArea = null
            //             model.aquacultureFarmNameAndRegistrationNo = null
            //         },
            //         disabled: viewOnly,
            //         text: () => i18n.global.t("model.certificateRequest.additionalInformation.refIsAquaculture")
            //     }, conditionFormChecker({ props, data, executeKey: 'inputPropField', params: { field } }))),
            // }),
            // createFieldCheckbox({
            //     visible: ({ field }) => conditionFormChecker({ props, data, executeKey: 'visibleField', params: { field } }),
            //     key: `${prefix}isWildCaught`,
            //     colProp: () => ({ xs: 24, md: 8 }),
            //     formItemProp: () => ({ labelCol: { xs: 24, md: 4 }, wrapperCol: { xs: 24, md: 20 } }),
            //     labelRender: ({ field }) => checkTooltipLabel({ field, parentModel: model.refParent, model}),
            //     inputProp: ({ field }) => (lodash.merge({
            //         checked: model.isWildCaught,
            //         'onUpdate:checked': checked => {
            //             model.isWildCaught = checked
            //             let key = model.isWildCaught ? 'Yes' : 'No'
            //             store.dispatch('resource/v1/master/lookup/cacheFindAllByGroup', { group: 'IS_WILD_CAUGHT', key, keyOperator: '=' }).then(list => {
            //                 model.refIsWildCaught = list[0]
            //             })
            //             model.catchArea = null
            //             // model.catchVesselNameAndNo = null
            //             model.fishVesselDetail = null
            //         },
            //         disabled: viewOnly,
            //         text: () => i18n.global.t("model.certificateRequest.additionalInformation.refIsWildCaught")
            //     }, conditionFormChecker({ props, data, executeKey: 'inputPropField', params: { field } }))),
            // }),
            // {
            //     key: `${prefix}refProductModeHiddenBlock`,
            //     visible: ({ field }) => conditionFormChecker({ props, data, executeKey: 'visibleField', params: { field } }),
            //     colProp: () => ({ xs: 24, md: 8 }),
            //     formItemRender: () => {
            //     }
            // },
            createFieldRadioGroup({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: 'visibleField', params: { field } }),
                key: `${prefix}refIsAquaculture`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t('model.certificateRequest.additionalInformation.refIsAquaculture'),
                labelRender: ({ field }) => checkTooltipLabel({ field, keySuffix: "value", labelTitle: field.label(), parentModel: model.refParent, model}),
                inputProp: ({ field }) => (lodash.merge({
                    value: model.refIsAquaculture,
                    'onUpdate:value': value => model.refIsAquaculture = value,
                    disabled: viewOnly,
                    list: callIsAquaculture,
                    optKey: "key",
                    optLabel: "value",
                }, conditionFormChecker({ props, data, executeKey: 'inputPropField', params: { field } }))),
                changeLog: { getValue: ({ record, field }) => lodash.get(record, `${field.key}.value`) }
            }),
            {
                key: `${prefix}refIsAquaculture`,
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: 'visibleField', params: { field } }),
                colProp: () => ({ xs: 24, md: 12 }),
                formItemRender: () => {
                }
            },
            createFieldInput({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: 'visibleField', params: { field } }),
                key: `${prefix}aquacultureArea`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t('model.certificateRequest.additionalInformation.aquacultureArea'),
                labelRender: ({ field }) => checkTooltipLabel({ field, labelTitle: field.label(), parentModel: model.refParent, model}),
                inputProp: ({ field }) => (lodash.merge({
                    value: model.aquacultureArea,
                    'onUpdate:value': value => model.aquacultureArea = value,
                    disabled: viewOnly
                }, conditionFormChecker({ props, data, executeKey: 'inputPropField', params: { field } })))
            }),
            {
                key: `${prefix}aquacultureArea`,
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: 'visibleField', params: { field } }),
                colProp: () => ({ xs: 24, md: 12 }),
                formItemRender: () => {
                }
            },
            createFieldTextArea({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: 'visibleField', params: { field } }),
                key: `${prefix}aquacultureFarmNameAndRegistrationNo`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t('model.certificateRequest.additionalInformation.aquacultureFarmNameAndRegistrationNo'),
                labelRender: ({ field }) => checkTooltipLabel({ field, labelTitle: field.label(), parentModel: model.refParent, model}),
                inputProp: ({ field }) => (lodash.merge({
                    value: model.aquacultureFarmNameAndRegistrationNo,
                    'onUpdate:value': value => model.aquacultureFarmNameAndRegistrationNo = value,
                    disabled: viewOnly
                }, conditionFormChecker({ props, data, executeKey: 'inputPropField', params: { field } })))
            }),
            {
                key: `${prefix}aquacultureFarmNameAndRegistrationNo`,
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: 'visibleField', params: { field } }),
                colProp: () => ({ xs: 24, md: 12 }),
                formItemRender: () => {
                }
            },
            createFieldRadioGroup({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: 'visibleField', params: { field } }),
                key: `${prefix}refIsWildCaught`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t('model.certificateRequest.additionalInformation.refIsWildCaught'),
                labelRender: ({ field }) => checkTooltipLabel({ field, keySuffix: "value", labelTitle: field.label(), parentModel: model.refParent, model}),
                inputProp: ({ field }) => (lodash.merge({
                    value: model.refIsWildCaught,
                    'onUpdate:value': value => model.refIsWildCaught = value,
                    disabled: viewOnly,
                    list: callIsWildCaught,
                    optKey: "key",
                    optLabel: "value",
                }, conditionFormChecker({ props, data, executeKey: 'inputPropField', params: { field } }))),
                changeLog: { getValue: ({ record, field }) => lodash.get(record, `${field.key}.value`) }
            }),
            {
                key: `${prefix}refIsWildCaught`,
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: 'visibleField', params: { field } }),
                colProp: () => ({ xs: 24, md: 12 }),
                formItemRender: () => {
                }
            },
            createFieldInput({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: 'visibleField', params: { field } }),
                key: `${prefix}catchArea`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t('model.certificateRequest.additionalInformation.catchArea'),
                labelRender: ({ field }) => checkTooltipLabel({ field, labelTitle: field.label(), parentModel: model.refParent, model}),
                inputProp: ({ field }) => (lodash.merge({
                    value: model.catchArea,
                    'onUpdate:value': value => model.catchArea = value,
                    disabled: viewOnly
                }, conditionFormChecker({ props, data, executeKey: 'inputPropField', params: { field } })))
            }),
            {
                key: `${prefix}catchArea`,
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: 'visibleField', params: { field } }),
                colProp: () => ({ xs: 24, md: 12 }),
                formItemRender: () => {
                }
            },
            /*createFieldInput({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: 'visibleField', params: { field } }),
                key: `${prefix}catchVesselNameAndNo`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t('model.certificateRequest.additionalInformation.catchVesselNameAndNo'),
                labelRender: ({ field }) => checkTooltipLabel({ field, labelTitle: field.label(), parentModel: model.refParent, model}),
                inputProp: ({ field }) => (lodash.merge({
                    value: model.catchVesselNameAndNo,
                    'onUpdate:value': value => model.catchVesselNameAndNo = value,
                    disabled: viewOnly
                }, conditionFormChecker({ props, data, executeKey: 'inputPropField', params: { field } })))
            }),*/
            createFieldTextArea({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: 'visibleField', params: { field } }),
                key: `${prefix}fishVesselDetail`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t('model.certificateRequest.additionalInformation.fishVesselDetail'),
                labelRender: ({ field }) => checkTooltipLabel({ field, labelTitle: field.label(), parentModel: model.refParent, model}),
                inputProp: ({ field }) => (lodash.merge({
                    value: model.fishVesselDetail,
                    'onUpdate:value': value => model.fishVesselDetail = value,
                    disabled: viewOnly
                }, conditionFormChecker({ props, data, executeKey: 'inputPropField', params: { field } })))
            }),
            {
                key: `${prefix}fishVesselDetail`,
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: 'visibleField', params: { field } }),
                colProp: () => ({ xs: 24, md: 12 }),
                formItemRender: () => {
                }
            },
            createFieldCheckbox({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: 'visibleField', params: { field } }),
                key: `${prefix}isProcessedDairyProduct`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => ' ',
                labelRender: ({ field }) => checkTooltipLabel({ field, labelTitle: field.label(), parentModel: model.refParent, model}),
                inputProp: ({ field }) => (lodash.merge({
                    checked: model.isProcessedDairyProduct,
                    'onUpdate:checked': checked => model.isProcessedDairyProduct = checked,
                    disabled: viewOnly,
                    text: () => i18n.global.t("model.certificateRequest.additionalInformation.processedDairyProduct")
                }, conditionFormChecker({ props, data, executeKey: 'inputPropField', params: { field } }))),
            }),
            {
                key: `${prefix}isProcessedDairyProductHiddenBlock`,
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: 'visibleField', params: { field } }),
                colProp: () => ({ xs: 24, md: 12 }),
                formItemRender: () => {
                }
            },
            createFieldSelect({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: 'visibleField', params: { field } }),
                key: `${prefix}refProducedInTheCountry`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t('model.certificateRequest.additionalInformation.refProducedInTheCountry'),
                labelRender: ({ field }) => checkTooltipLabel({ field, keySuffix: "nameTh", labelTitle: field.label(), parentModel: model.refParent, model}),
                inputProp: ({ field }) => (lodash.merge({
                    value: model.refProducedInTheCountry,
                    'onUpdate:value': value => model.refProducedInTheCountry = value,
                    disabled: viewOnly,
                    list:  ({ searchQuery }) => {
                        const where =  [
                            { name: 'haveChildren', operator: '=', value: false },
                        ]
                        return Promise.all([store.dispatch('resource/v1/master/country/cacheFindAll', { where, options: { force: true }})])
                            .then(arr => {
                                return filter({
                                    list: arr[0],
                                    where: [
                                        { name: "alpha", type: "String", isNot: true, operator: 'in', value: ['THA', 'DOF'] },
                                        { openBucket: true, name: "nameEn", type: "String", operator: 'like', value: searchQuery },
                                        { closeBucket: true, logic: 'OR', name: "nameTh", type: 'String', operator: 'like', value: searchQuery }
                                    ],
                                    sort: [{ name: "nameEn", type: "ASC" }] })
                            })
                    },
                    optKey: "id",
                    optLabel: "nameEn",
                }, conditionFormChecker({ props, data, executeKey: 'inputPropField', params: { field } }))),
                changeLog: { getValue: ({ record, field }) => lodash.get(record, `${field.key}.nameEn`) }
            }),
            createFieldInput({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: 'visibleField', params: { field } }),
                key: `${prefix}approvalNo`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t('model.certificateRequest.additionalInformation.approvalNo'),
                labelRender: ({ field }) => checkTooltipLabel({ field, labelTitle: field.label(), parentModel: model.refParent, model}),
                inputProp: ({ field }) => (lodash.merge({
                    value: model.approvalNo,
                    'onUpdate:value': value => model.approvalNo = value,
                    disabled: viewOnly
                }, conditionFormChecker({ props, data, executeKey: 'inputPropField', params: { field } })))
            }),
            createFieldRadioGroup({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: 'visibleField', params: { field } }),
                key: `${prefix}refProductOn`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t('model.certificateRequest.additionalInformation.refProductOn'),
                labelRender: ({ field }) => checkTooltipLabel({ field, keySuffix: "value", labelTitle: field.label(), parentModel: model.refParent, model}),
                inputProp: ({ field }) => (lodash.merge({
                    value: model.refProductOn,
                    'onUpdate:value': value => model.refProductOn = value,
                    disabled: viewOnly,
                    list: callProducedOn,
                    optKey: "key",
                    optLabel: "value",
                }, conditionFormChecker({ props, data, executeKey: 'inputPropField', params: { field } }))),
                changeLog: { getValue: ({ record, field }) => lodash.get(record, `${field.key}.value`) }
            }),
            {
                key: `${prefix}refProductOnHiddenBlock`,
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: 'visibleField', params: { field } }),
                colProp: () => ({ xs: 24, md: 12 }),
                formItemRender: () => {
                }
            },
            createFieldDate({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: 'visibleField', params: { field } }),
                key: `${prefix}productOnDate`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t('model.certificateRequest.additionalInformation.productOnDate'),
                labelRender: ({ field }) => checkTooltipLabel({ field, labelTitle: field.label(), parentModel: model.refParent, model}),
                inputProp: ({ field }) => (lodash.merge({
                    value: model.productOnDate,
                    disabled: viewOnly,
                    locale: 'en',
                    'onUpdate:value': value => (model.productOnDate = value)
                }, conditionFormChecker({ props, data, executeKey: 'inputPropField', params: { field } }))),
            }),
            {
                key: `${prefix}productOnDateHiddenBlock`,
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: 'visibleField', params: { field } }),
                colProp: () => ({ xs: 24, md: 12 }),
                formItemRender: () => {
                }
            },
            createFieldDate({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: 'visibleField', params: { field } }),
                key: `${prefix}productOnBetweenDate1`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t('model.certificateRequest.additionalInformation.productOnBetweenDate1'),
                labelRender: ({ field }) => checkTooltipLabel({ field, labelTitle: field.label(), parentModel: model.refParent, model}),
                inputProp: ({ field }) => (lodash.merge({
                    value: model.productOnBetweenDate1,
                    disabled: viewOnly,
                    locale: 'en',
                    'onUpdate:value': value => (model.productOnBetweenDate1 = value)
                }, conditionFormChecker({ props, data, executeKey: 'inputPropField', params: { field } }))),
            }),
            createFieldDate({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: 'visibleField', params: { field } }),
                key: `${prefix}productOnBetweenDate2`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t('model.certificateRequest.additionalInformation.productOnBetweenDate2'),
                labelRender: ({ field }) => checkTooltipLabel({ field, labelTitle: field.label(), parentModel: model.refParent, model}),
                inputProp: ({ field }) => (lodash.merge({
                    value: model.productOnBetweenDate2,
                    disabled: viewOnly,
                    locale: 'en',
                    'onUpdate:value': value => (model.productOnBetweenDate2 = value)
                }, conditionFormChecker({ props, data, executeKey: 'inputPropField', params: { field } }))),
            }),
            createFieldSelect({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: 'visibleField', params: { field } }),
                key: `${prefix}refApprovalCountry`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t('model.certificateRequest.additionalInformation.refApprovalCountry'),
                labelRender: ({ field }) => checkTooltipLabel({ field, keySuffix: "nameTh", labelTitle: field.label(), parentModel: model.refParent, model}),
                inputProp: ({ field }) => (lodash.merge({
                    value: model.refApprovalCountry,
                    'onUpdate:value': value => model.refApprovalCountry = value,
                    disabled: viewOnly,
                    list:  ({ searchQuery }) => {
                        const where =  [
                            { name: 'haveChildren', operator: '=', value: false },
                        ]
                        return Promise.all([store.dispatch('resource/v1/master/country/cacheFindAll', { where, options: { force: true }})])
                            .then(arr => {
                                return filter({
                                    list: arr[0],
                                    where: [
                                        { name: "alpha", type: "String", isNot: true, operator: 'in', value: ['THA', 'DOF'] },
                                        { openBucket: true, name: "nameEn", type: "String", operator: 'like', value: searchQuery },
                                        { closeBucket: true, logic: 'OR', name: "nameTh", type: 'String', operator: 'like', value: searchQuery }
                                    ],
                                    sort: [{ name: "nameEn", type: "ASC" }] })
                            })
                    },
                    optKey: "id",
                    optLabel: "nameEn",
                }, conditionFormChecker({ props, data, executeKey: 'inputPropField', params: { field } }))),
                changeLog: { getValue: ({ record, field }) => lodash.get(record, `${field.key}.nameEn`) }
            }),
            {
                key: `${prefix}refApprovalCountryHiddenBlock`,
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: 'visibleField', params: { field } }),
                colProp: () => ({ xs: 24, md: 12 }),
                formItemRender: () => {
                }
            },

            //  ----------------- new field
            createFieldInput({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: 'visibleField', params: { field } }),
                key: `${prefix}slaughterhouse`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t('model.certificateRequest.additionalInformation.slaughterhouse'),
                labelRender: ({ field }) => checkTooltipLabel({ field, labelTitle: field.label(), parentModel: model.refParent, model}),
                inputProp: ({ field }) => (lodash.merge({
                    value: model.slaughterhouse,
                    'onUpdate:value': value => model.slaughterhouse = value,
                    disabled: viewOnly
                }, conditionFormChecker({ props, data, executeKey: 'inputPropField', params: { field } })))
            }),
            createFieldInput({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: 'visibleField', params: { field } }),
                key: `${prefix}dairyProducingCountries`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t('model.certificateRequest.additionalInformation.dairyProducingCountries'),
                labelRender: ({ field }) => checkTooltipLabel({ field, labelTitle: field.label(), parentModel: model.refParent, model}),
                inputProp: ({ field }) => (lodash.merge({
                    value: model.dairyProducingCountries,
                    'onUpdate:value': value => model.dairyProducingCountries = value,
                    disabled: viewOnly
                }, conditionFormChecker({ props, data, executeKey: 'inputPropField', params: { field } })))
            }),
            createFieldInput({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: 'visibleField', params: { field } }),
                key: `${prefix}euApprovalNo`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t('model.certificateRequest.additionalInformation.euApprovalNo'),
                labelRender: ({ field }) => checkTooltipLabel({ field, labelTitle: field.label(), parentModel: model.refParent, model}),
                inputProp: ({ field }) => (lodash.merge({
                    value: model.euApprovalNo,
                    'onUpdate:value': value => model.euApprovalNo = value,
                    disabled: viewOnly
                }, conditionFormChecker({ props, data, executeKey: 'inputPropField', params: { field } })))
            }),
            {
                key: `${prefix}euApprovalNo`,
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: 'visibleField', params: { field } }),
                colProp: () => ({ xs: 24, md: 12 }),
                formItemRender: () => {
                }
            },
            createFieldCheckbox({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: 'visibleField', params: { field } }),
                key: `${prefix}isProduceDairyPeriod`,
                colProp: () => ({ xs: 24, md: 8 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 12 }, wrapperCol: { xs: 24, md: 12 } }),
                label: () => i18n.global.t('model.certificateRequest.additionalInformation.isProduceDairyPeriod'),
                labelRender: ({ field }) => checkTooltipLabel({ field, labelTitle: field.label(), parentModel: model.refParent, model}),
                inputProp: ({ field }) => (lodash.merge({
                    checked: model.isProduceDairyPeriod,
                    'onUpdate:checked': checked => {
                        model.dairyProduceEndDateStr = null
                        model.isProduceDairyPeriod = checked
                    },
                    disabled: viewOnly,
                    // text: () => i18n.global.t("model.certificateRequest.additionalInformation.goodCertifiedAsLabel.canningIndustry")
                }, conditionFormChecker({ props, data, executeKey: 'inputPropField', params: { field } }))),
            }),
            {
                key: `${prefix}isProduceDairyPeriod`,
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: 'visibleField', params: { field } }),
                colProp: () => ({ xs: 24, md: 16 }),
                formItemRender: () => {
                }
            },
            createFieldInput({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: 'visibleField', params: { field } }),
                key: `${prefix}dairyProduceStartDateStr`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t('model.certificateRequest.additionalInformation.dairyProduceStartDateStr'),
                labelRender: ({ field }) => checkTooltipLabel({ field, labelTitle: field.label(), parentModel: model.refParent, model}),
                inputProp: ({ field }) => (lodash.merge({
                    value: model.dairyProduceStartDateStr,
                    'onUpdate:value': value => model.dairyProduceStartDateStr = value,
                    disabled: viewOnly
                }, conditionFormChecker({ props, data, executeKey: 'inputPropField', params: { field } })))
            }),
            createFieldInput({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: 'visibleField', params: { field } }),
                key: `${prefix}dairyProduceEndDateStr`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t('model.certificateRequest.additionalInformation.dairyProduceEndDateStr'),
                labelRender: ({ field }) => checkTooltipLabel({ field, labelTitle: field.label(), parentModel: model.refParent, model}),
                inputProp: ({ field }) => (lodash.merge({
                    value: model.dairyProduceEndDateStr,
                    'onUpdate:value': value => model.dairyProduceEndDateStr = value,
                    disabled: viewOnly && !model.isProduceDairyPeriod
                }, conditionFormChecker({ props, data, executeKey: 'inputPropField', params: { field } })))
            }),
            createFieldInput({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: 'visibleField', params: { field } }),
                key: `${prefix}eggOriginCountries`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t('model.certificateRequest.additionalInformation.eggOriginCountries'),
                labelRender: ({ field }) => checkTooltipLabel({ field, labelTitle: field.label(), parentModel: model.refParent, model}),
                inputProp: ({ field }) => (lodash.merge({
                    value: model.eggOriginCountries,
                    'onUpdate:value': value => model.eggOriginCountries = value,
                    disabled: viewOnly
                }, conditionFormChecker({ props, data, executeKey: 'inputPropField', params: { field } })))
            }),
            //  ----------------------------------------------------------------------------------------

            createFieldInput({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: 'visibleField', params: { field } }),
                key: `${prefix}regionOfOrigin`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t('model.certificateRequest.additionalInformation.regionOfOrigin'),
                labelRender: ({ field }) => checkTooltipLabel({ field, labelTitle: field.label(), parentModel: model.refParent, model}),
                inputProp: ({ field }) => (lodash.merge({
                    value: model.regionOfOrigin,
                    'onUpdate:value': value => model.regionOfOrigin = value,
                    disabled: viewOnly
                }, conditionFormChecker({ props, data, executeKey: 'inputPropField', params: { field } })))
            }),
            createFieldInput({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: 'visibleField', params: { field } }),
                key: `${prefix}approvalZone`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t('model.certificateRequest.additionalInformation.approvalZone'),
                labelRender: ({ field }) => checkTooltipLabel({ field, labelTitle: field.label(), parentModel: model.refParent, model}),
                inputProp: ({ field }) => (lodash.merge({
                    value: model.approvalZone,
                    'onUpdate:value': value => model.approvalZone = value,
                    disabled: viewOnly
                }, conditionFormChecker({ props, data, executeKey: 'inputPropField', params: { field } })))
            }),
            createFieldInput({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: 'visibleField', params: { field } }),
                key: `${prefix}regionOfDestination`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t('model.certificateRequest.additionalInformation.regionOfDestination'),
                labelRender: ({ field }) => checkTooltipLabel({ field, labelTitle: field.label(), parentModel: model.refParent, model}),
                inputProp: ({ field }) => (lodash.merge({
                    value: model.regionOfDestination,
                    'onUpdate:value': value => model.regionOfDestination = value,
                    disabled: viewOnly
                }, conditionFormChecker({ props, data, executeKey: 'inputPropField', params: { field } })))
            }),
            createFieldInput({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: 'visibleField', params: { field } }),
                key: `${prefix}approvalZone2`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t('model.certificateRequest.additionalInformation.approvalZone2'),
                labelRender: ({ field }) => checkTooltipLabel({ field, labelTitle: field.label(), parentModel: model.refParent, model}),
                inputProp: ({ field }) => (lodash.merge({
                    value: model.approvalZone2,
                    'onUpdate:value': value => model.approvalZone2 = value,
                    disabled: viewOnly
                }, conditionFormChecker({ props, data, executeKey: 'inputPropField', params: { field } })))
            }),
            {
                key: `${prefix}nameOfOperator`,
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: 'visibleField', params: { field } }),
                colProp: () => ({ xs: 24, md: 4 }),
                formItemRender: () => {
                }
            },
            {
                key: `${prefix}nameOfOperator`,
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: 'visibleField', params: { field } }),
                colProp: () => ({ xs: 24, md: 20 }),
                formItemRender: () => {
                    return <span>
                        <Button
                            class="btn-primary mt-2"
                            disabled={viewOnly}
                            size="small" onClick={
                                () => {
                                    model.nameOfOperator = model.consigneeName
                                    model.addressOfOperator = model.consigneeAddress
                                    model.cityOfOperator = model.consigneeCity
                                    model.postcodeOfOperator = model.consigneePostcode
                                    model.refOperatorCountry = model.refExportCountry
                                    model.isoOperatorCountry = model.isoExportCountry
                                    model.phoneNoOfOperator = model.consigneePhoneNo
                                }
                            }
                        >
                            {i18n.global.t("views.certificate.certificateRequest.button.copyAddressConsignee")}
                            <CIcon file="copy.svg"></CIcon>
                        </Button>
                    </span>
                }
            },
            createFieldInput({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: 'visibleField', params: { field } }),
                key: `${prefix}nameOfOperator`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t('model.certificateRequest.additionalInformation.nameOfOperator'),
                labelRender: ({ field }) => checkTooltipLabel({ field, labelTitle: field.label(), parentModel: model.refParent, model}),
                inputProp: ({ field }) => (lodash.merge({
                    value: model.nameOfOperator,
                    'onUpdate:value': value => model.nameOfOperator = value,
                    disabled: viewOnly
                }, conditionFormChecker({ props, data, executeKey: 'inputPropField', params: { field } })))
            }),
            createFieldInput({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: 'visibleField', params: { field } }),
                key: `${prefix}addressOfOperator`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t('model.certificateRequest.additionalInformation.address'),
                labelRender: ({ field }) => checkTooltipLabel({ field, labelTitle: field.label(), parentModel: model.refParent, model}),
                inputProp: ({ field }) => (lodash.merge({
                    value: model.addressOfOperator,
                    'onUpdate:value': value => model.addressOfOperator = value,
                    disabled: viewOnly
                }, conditionFormChecker({ props, data, executeKey: 'inputPropField', params: { field } })))
            }),
            createFieldInput({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: 'visibleField', params: { field } }),
                key: `${prefix}cityOfOperator`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t('model.certificateRequest.additionalInformation.city'),
                labelRender: ({ field }) => checkTooltipLabel({ field, labelTitle: field.label(), parentModel: model.refParent, model}),
                inputProp: ({ field }) => (lodash.merge({
                    value: model.cityOfOperator,
                    'onUpdate:value': value => model.cityOfOperator = value,
                    disabled: viewOnly
                }, conditionFormChecker({ props, data, executeKey: 'inputPropField', params: { field } })))
            }),
            createFieldInput({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: 'visibleField', params: { field } }),
                key: `${prefix}postcodeOfOperator`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t('model.certificateRequest.additionalInformation.zipCode'),
                labelRender: ({ field }) => checkTooltipLabel({ field, labelTitle: field.label(), parentModel: model.refParent, model}),
                inputProp: ({ field }) => (lodash.merge({
                    value: model.postcodeOfOperator,
                    'onUpdate:value': value => model.postcodeOfOperator = value,
                    disabled: viewOnly
                }, conditionFormChecker({ props, data, executeKey: 'inputPropField', params: { field } })))
            }),
            createFieldSelect({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: 'visibleField', params: { field } }),
                key: `${prefix}refOperatorCountry`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t('model.certificateRequest.additionalInformation.refOperatorCountry'),
                labelRender: ({ field }) => checkTooltipLabel({ field, keySuffix: "nameEn", labelTitle: field.label(), parentModel: model.refParent, model }),
                inputProp: ({ field }) => (lodash.merge({
                    value: model.refOperatorCountry,
                    'onUpdate:value': value => {
                        model.refOperatorCountry = value
                        model.isoOperatorCountry = value?.isoTwoDigit?.[0]?.code
                    },
                    disabled: viewOnly,
                    list:  ({ searchQuery }) => {
                        const where =  [
                            { name: 'isSpecial', operator: '=', value: false },
                            { name: 'haveChildren', operator: '=', value: false },
                        ]
                        return Promise.all([callCompanyCountries({ refCompanyId: modelRef.refCompany?.id }), store.dispatch('resource/v1/master/country/cacheFindAll', { where, options: { force: true }})])
                            .then(arr => {
                                const allComapnyCountry = arr[0].flatMap(d => d.children.length > 0 ? d.children : [d])
                                const allComapnyCountryId = allComapnyCountry.map(c => c.id)
                                const allIsNotSpecialCountry = arr[1].filter(d => !allComapnyCountryId.includes(d.id))
                                const listExportCountries = [...new Set([...allComapnyCountry,...allIsNotSpecialCountry])]

                                return filter({
                                    list: listExportCountries,
                                    where: [
                                        { name: "alpha", type: "String", isNot: true, operator: 'in', value: ['THA', 'DOF'] },
                                        { openBucket: true, name: "nameEn", type: "String", operator: 'like', value: searchQuery },
                                        { closeBucket: true, logic: 'OR', name: "nameTh", type: 'String', operator: 'like', value: searchQuery }
                                    ],
                                    sort: [{ name: "nameEn", type: "ASC" }] })
                            })
                    },
                    optKey: "id",
                    optLabel: "nameEn",
                }, conditionFormChecker({ props, data, executeKey: 'inputPropField', params: { field } }))),
                changeLog: { getValue: ({ record, field }) => lodash.get(record, `${field.key}.nameEn`) }
            }),
            createFieldSelect({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: 'visibleField', params: { field } }),
                key: `${prefix}isoOperatorCountry`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t('model.certificateRequest.additionalInformation.isoOperatorCountry') ,
                labelRender: ({ field }) => checkTooltipLabel({ field, labelTitle: field.label(), parentModel: model.refParent, model }),
                inputProp: ({ field }) => (lodash.merge({
                    value: { code: model.isoOperatorCountry },
                    'onUpdate:value': value => {
                        model.isoOperatorCountry = value?.code
                    },
                    list: () => Promise.resolve(model?.refOperatorCountry?.isoTwoDigit).then(iso =>  (iso)),
                    optKey: "code",
                    optLabel: "code",
                    disabled: viewOnly ,
                }, conditionFormChecker({ props, data, executeKey: 'inputPropField', params: { field } }))),
                changeLog: { getValue: ({ record, field }) => lodash.get(record, `${field.key}`) }
            }),
            createFieldInput({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: 'visibleField', params: { field } }),
                key: `${prefix}phoneNoOfOperator`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t('model.certificateRequest.additionalInformation.telephone'),
                labelRender: ({ field }) => checkTooltipLabel({ field, labelTitle: field.label(), parentModel: model.refParent, model}),
                inputProp: ({ field }) => (lodash.merge({
                    value: model.phoneNoOfOperator,
                    'onUpdate:value': value => model.phoneNoOfOperator = value,
                    disabled: viewOnly
                }, conditionFormChecker({ props, data, executeKey: 'inputPropField', params: { field } })))
            }),
            {
                key: `${prefix}phoneNoOfOperatorHiddenBlock`,
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: 'visibleField', params: { field } }),
                colProp: () => ({ xs: 24, md: 12 }),
                formItemRender: () => {
                }
            },
            {
                key: `${prefix}namePlaceOfDestination`,
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: 'visibleField', params: { field } }),
                colProp: () => ({ xs: 24, md: 4 }),
                formItemRender: () => {
                }
            },
            {
                key: `${prefix}namePlaceOfDestination`,
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: 'visibleField', params: { field } }),
                colProp: () => ({ xs: 24, md: 20 }),
                formItemRender: () => {
                    return <span>
                        <Button
                            class="btn-primary mt-2"
                            disabled={viewOnly}
                            size="small" onClick={
                            () => {
                                model.namePlaceOfDestination = model.consigneeName
                                model.addressPlaceOfDestination = model.consigneeAddress
                                model.refPlaceOfDestinationCountry = model.refExportCountry
                                model.isoPlaceOfDestinationCountry = model.isoExportCountry
                            }
                        }
                        >
                            {i18n.global.t("views.certificate.certificateRequest.button.copyAddressConsignee")}
                            <CIcon file="copy.svg"></CIcon>
                        </Button>
                    </span>
                }
            },
            createFieldInput({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: 'visibleField', params: { field } }),
                key: `${prefix}namePlaceOfDestination`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t('model.certificateRequest.additionalInformation.namePlaceOfDestination'),
                labelRender: ({ field }) => checkTooltipLabel({ field, labelTitle: field.label(), parentModel: model.refParent, model}),
                inputProp: ({ field }) => (lodash.merge({
                    value: model.namePlaceOfDestination,
                    'onUpdate:value': value => model.namePlaceOfDestination = value,
                    disabled: viewOnly
                }, conditionFormChecker({ props, data, executeKey: 'inputPropField', params: { field } })))
            }),
            createFieldInput({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: 'visibleField', params: { field } }),
                key: `${prefix}addressPlaceOfDestination`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t('model.certificateRequest.additionalInformation.address'),
                labelRender: ({ field }) => checkTooltipLabel({ field, labelTitle: field.label(), parentModel: model.refParent, model}),
                inputProp: ({ field }) => (lodash.merge({
                    value: model.addressPlaceOfDestination,
                    'onUpdate:value': value => model.addressPlaceOfDestination = value,
                    disabled: viewOnly
                }, conditionFormChecker({ props, data, executeKey: 'inputPropField', params: { field } })))
            }),
            createFieldSelect({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: 'visibleField', params: { field } }),
                key: `${prefix}refPlaceOfDestinationCountry`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t('model.certificateRequest.additionalInformation.refPlaceOfDestinationCountry'),
                labelRender: ({ field }) => checkTooltipLabel({ field, keySuffix: "nameEn", labelTitle: field.label(), parentModel: model.refParent, model }),
                inputProp: ({ field }) => (lodash.merge({
                    value: model.refPlaceOfDestinationCountry,
                    'onUpdate:value': value => {
                        model.refPlaceOfDestinationCountry = value
                        model.isoPlaceOfDestinationCountry = value?.isoTwoDigit?.[0]?.code
                    },
                    disabled: viewOnly,
                    list:  ({ searchQuery }) => {
                        const where =  [
                            { name: 'isSpecial', operator: '=', value: false },
                            { name: 'haveChildren', operator: '=', value: false },
                        ]
                        return Promise.all([callCompanyCountries({ refCompanyId: modelRef.refCompany?.id }), store.dispatch('resource/v1/master/country/cacheFindAll', { where, options: { force: true }})])
                            .then(arr => {
                                const allComapnyCountry = arr[0].flatMap(d => d.children.length > 0 ? d.children : [d])
                                const allComapnyCountryId = allComapnyCountry.map(c => c.id)
                                const allIsNotSpecialCountry = arr[1].filter(d => !allComapnyCountryId.includes(d.id))
                                const listExportCountries = [...new Set([...allComapnyCountry,...allIsNotSpecialCountry])]

                                return filter({
                                    list: listExportCountries,
                                    where: [
                                        { name: "alpha", type: "String", isNot: true, operator: 'in', value: ['THA', 'DOF'] },
                                        { openBucket: true, name: "nameEn", type: "String", operator: 'like', value: searchQuery },
                                        { closeBucket: true, logic: 'OR', name: "nameTh", type: 'String', operator: 'like', value: searchQuery }
                                    ],
                                    sort: [{ name: "nameEn", type: "ASC" }] })
                            })
                    },
                    optKey: "id",
                    optLabel: "nameEn",
                }, conditionFormChecker({ props, data, executeKey: 'inputPropField', params: { field } }))),
                changeLog: { getValue: ({ record, field }) => lodash.get(record, `${field.key}.nameEn`) }
            }),
            createFieldSelect({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: 'visibleField', params: { field } }),
                key: `${prefix}isoPlaceOfDestinationCountry`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t('model.certificateRequest.additionalInformation.isoPlaceOfDestinationCountry') ,
                labelRender: ({ field }) => checkTooltipLabel({ field, labelTitle: field.label(), parentModel: model.refParent, model }),
                inputProp: ({ field }) => (lodash.merge({
                    value: { code: model.isoPlaceOfDestinationCountry },
                    'onUpdate:value': value => {
                        model.isoPlaceOfDestinationCountry = value?.code
                    },
                    list: () => Promise.resolve(model?.refPlaceOfDestinationCountry?.isoTwoDigit).then(iso =>  (iso)),
                    optKey: "code",
                    optLabel: "code",
                    disabled: viewOnly ,
                }, conditionFormChecker({ props, data, executeKey: 'inputPropField', params: { field } }))),
                changeLog: { getValue: ({ record, field }) => lodash.get(record, `${field.key}`) }
            }),
            createFieldInput({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: 'visibleField', params: { field } }),
                key: `${prefix}regNoPlaceOfDestination`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t('model.certificateRequest.additionalInformation.regNoPlaceOfDestination'),
                labelRender: ({ field }) => checkTooltipLabel({ field, labelTitle: field.label(), parentModel: model.refParent, model}),
                inputProp: ({ field }) => (lodash.merge({
                    value: model.regNoPlaceOfDestination,
                    'onUpdate:value': value => model.regNoPlaceOfDestination = value,
                    disabled: viewOnly
                }, conditionFormChecker({ props, data, executeKey: 'inputPropField', params: { field } })))
            }),
            {
                key: `${prefix}regNoPlaceOfDestination`,
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: 'visibleField', params: { field } }),
                colProp: () => ({ xs: 24, md: 12 }),
                formItemRender: () => {
                }
            },
            createFieldInput({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: 'visibleField', params: { field } }),
                key: `${prefix}accompanyingDocumentType`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t('model.certificateRequest.additionalInformation.accompanyingDocumentType'),
                labelRender: ({ field }) => checkTooltipLabel({ field, labelTitle: field.label(), parentModel: model.refParent, model}),
                inputProp: ({ field }) => (lodash.merge({
                    value: model.accompanyingDocumentType,
                    'onUpdate:value': value => model.accompanyingDocumentType = value,
                    disabled: viewOnly
                }, conditionFormChecker({ props, data, executeKey: 'inputPropField', params: { field } })))
            }),
            createFieldInput({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: 'visibleField', params: { field } }),
                key: `${prefix}accompanyingDocumentNo`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t('model.certificateRequest.additionalInformation.accompanyingDocumentNo'),
                labelRender: ({ field }) => checkTooltipLabel({ field, labelTitle: field.label(), parentModel: model.refParent, model}),
                inputProp: ({ field }) => (lodash.merge({
                    value: model.accompanyingDocumentNo,
                    'onUpdate:value': value => model.accompanyingDocumentNo = value,
                    disabled: viewOnly
                }, conditionFormChecker({ props, data, executeKey: 'inputPropField', params: { field } })))
            }),
            createFieldSelect({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: 'visibleField', params: { field } }),
                key: `${prefix}refAccompanyingDocumentCountry`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t('model.certificateRequest.additionalInformation.refAccompanyingDocumentCountry'),
                labelRender: ({ field }) => checkTooltipLabel({ field, keySuffix: "nameEn", labelTitle: field.label(), parentModel: model.refParent, model }),
                inputProp: ({ field }) => (lodash.merge({
                    value: model.refAccompanyingDocumentCountry,
                    'onUpdate:value': value => {
                        model.refAccompanyingDocumentCountry = value
                        model.isoAccompanyingDocumentCountry = value?.isoTwoDigit?.[0]?.code
                    },
                    disabled: viewOnly,
                    list:  ({ searchQuery }) => {
                        const where =  [
                            { name: 'haveChildren', operator: '=', value: false },
                        ]
                        return Promise.all([store.dispatch('resource/v1/master/country/cacheFindAll', { where, options: { force: true }})])
                            .then(arr => {
                                return filter({
                                    list: arr[0],
                                    where: [
                                        { name: "alpha", type: "String", isNot: true, operator: 'in', value: ['THA', 'DOF'] },
                                        { openBucket: true, name: "nameEn", type: "String", operator: 'like', value: searchQuery },
                                        { closeBucket: true, logic: 'OR', name: "nameTh", type: 'String', operator: 'like', value: searchQuery }
                                    ],
                                    sort: [{ name: "nameEn", type: "ASC" }] })
                            })
                    },
                    optKey: "id",
                    optLabel: "nameEn",
                }, conditionFormChecker({ props, data, executeKey: 'inputPropField', params: { field } }))),
                changeLog: { getValue: ({ record, field }) => lodash.get(record, `${field.key}.nameEn`) }
            }),
            createFieldSelect({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: 'visibleField', params: { field } }),
                key: `${prefix}isoAccompanyingDocumentCountry`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t('model.certificateRequest.additionalInformation.isoAccompanyingDocumentCountry') ,
                labelRender: ({ field }) => checkTooltipLabel({ field, labelTitle: field.label(), parentModel: model.refParent, model }),
                inputProp: ({ field }) => (lodash.merge({
                    value: { code: model.isoAccompanyingDocumentCountry },
                    'onUpdate:value': value => {
                        model.isoAccompanyingDocumentCountry = value?.code
                    },
                    list: () => Promise.resolve(model?.refAccompanyingDocumentCountry?.isoTwoDigit).then(iso =>  (iso)),
                    optKey: "code",
                    optLabel: "code",
                    disabled: viewOnly ,
                }, conditionFormChecker({ props, data, executeKey: 'inputPropField', params: { field } }))),
                changeLog: { getValue: ({ record, field }) => lodash.get(record, `${field.key}`) }
            }),
            createFieldCheckbox({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: 'visibleField', params: { field } }),
                key: `${prefix}isCanningIndustry`,
                colProp: () => ({ xs: 24, md: 8 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 12 }, wrapperCol: { xs: 24, md: 12 } }),
                label: () => i18n.global.t('model.certificateRequest.additionalInformation.goodCertifiedAs'),
                labelRender: ({ field }) => checkTooltipLabel({ field, labelTitle: field.label(), parentModel: model.refParent, model}),
                inputProp: ({ field }) => (lodash.merge({
                    checked: model.isCanningIndustry,
                    'onUpdate:checked': checked => model.isCanningIndustry = checked,
                    disabled: viewOnly,
                    text: () => i18n.global.t("model.certificateRequest.additionalInformation.goodCertifiedAsLabel.canningIndustry")
                }, conditionFormChecker({ props, data, executeKey: 'inputPropField', params: { field } }))),
            }),
            createFieldCheckbox({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: 'visibleField', params: { field } }),
                key: `${prefix}isHumanConsumption`,
                colProp: () => ({ xs: 24, md: 4 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 2 }, wrapperCol: { xs: 24, md: 22 } }),
                labelRender: ({ field }) => checkTooltipLabel({ field, parentModel: model.refParent, model}),
                inputProp: ({ field }) => (lodash.merge({
                    checked: model.isHumanConsumption,
                    'onUpdate:checked': checked => model.isHumanConsumption = checked,
                    disabled: viewOnly,
                    text: () => i18n.global.t("model.certificateRequest.additionalInformation.goodCertifiedAsLabel.humanConsumption")
                }, conditionFormChecker({ props, data, executeKey: 'inputPropField', params: { field } }))),
            }),
            createFieldCheckbox({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: 'visibleField', params: { field } }),
                key: `${prefix}isFurtherProcessing`,
                colProp: () => ({ xs: 24, md: 4 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 2 }, wrapperCol: { xs: 24, md: 22 } }),
                label: () => ' ',
                labelRender: ({ field }) => checkTooltipLabel({ field, labelTitle: field.label(), parentModel: model.refParent, model}),
                inputProp: ({ field }) => (lodash.merge({
                    checked: model.isFurtherProcessing,
                    'onUpdate:checked': checked => model.isFurtherProcessing = checked,
                    disabled: viewOnly,
                    text: () => i18n.global.t("model.certificateRequest.additionalInformation.goodCertifiedAsLabel.isFurtherProcessing")
                }, conditionFormChecker({ props, data, executeKey: 'inputPropField', params: { field } }))),
            }),
            createFieldCheckbox({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: 'visibleField', params: { field } }),
                key: `${prefix}isLiveAquaticAnimalForHumanConsumption`,
                colProp: () => ({ xs: 24, md: 8 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 2 }, wrapperCol: { xs: 24, md: 22 } }),
                label: () => ' ',
                labelRender: ({ field }) => checkTooltipLabel({ field, labelTitle: field.label(), parentModel: model.refParent, model}),
                inputProp: ({ field }) => (lodash.merge({
                    checked: model.isLiveAquaticAnimalForHumanConsumption,
                    'onUpdate:checked': checked => model.isLiveAquaticAnimalForHumanConsumption = checked,
                    disabled: viewOnly,
                    text: () => i18n.global.t("model.certificateRequest.additionalInformation.goodCertifiedAsLabel.isLiveAquaticAnimalForHumanConsumption")
                }, conditionFormChecker({ props, data, executeKey: 'inputPropField', params: { field } }))),
            }),
            createFieldInput({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: 'visibleField', params: { field } }),
                key: `${prefix}batchNo`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t('model.certificateRequest.additionalInformation.batchNo'),
                labelRender: ({ field }) => checkTooltipLabel({ field, labelTitle: field.label(), parentModel: model.refParent, model}),
                inputProp: ({ field }) => (lodash.merge({
                    value: model.batchNo,
                    'onUpdate:value': value => model.batchNo = value,
                    disabled: viewOnly
                }, conditionFormChecker({ props, data, executeKey: 'inputPropField', params: { field } })))
            }),
            {
                key: `${prefix}batchNoHiddenBlock`,
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: 'visibleField', params: { field } }),
                colProp: () => ({ xs: 24, md: 12 }),
                formItemRender: () => {
                }
            },
            createFieldCheckbox({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: 'visibleField', params: { field } }),
                key: `${prefix}isFinalConsumer`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t('model.certificateRequest.additionalInformation.finalConsumer'),
                labelRender: ({ field }) => checkTooltipLabel({ field, labelTitle: field.label(), parentModel: model.refParent, model}),
                inputProp: ({ field }) => (lodash.merge({
                    checked: model.isFinalConsumer,
                    'onUpdate:checked': checked => model.isFinalConsumer = checked,
                    disabled: viewOnly,
                    text: () => i18n.global.t("model.certificateRequest.additionalInformation.finalConsumer")
                }, conditionFormChecker({ props, data, executeKey: 'inputPropField', params: { field } }))),
            }),
            {
                key: `${prefix}isFinalConsumerHiddenBlock`,
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: 'visibleField', params: { field } }),
                colProp: () => ({ xs: 24, md: 12 }),
                formItemRender: () => {
                }
            },
            createFieldDate({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: 'visibleField', params: { field } }),
                key: `${prefix}freezingDate`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t('model.certificateRequest.additionalInformation.freezingDate'),
                labelRender: ({ field }) => checkTooltipLabel({ field, labelTitle: field.label(), parentModel: model.refParent, model}),
                inputProp: ({ field }) => (lodash.merge({
                    value: model.freezingDate,
                    'onUpdate:value': value => (model.freezingDate = value),
                    disabled: viewOnly,
                    locale: 'en',
                }, conditionFormChecker({ props, data, executeKey: 'inputPropField', params: { field } }))),
            }),
            {
                key: `${prefix}freezingDateHiddenBlock`,
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: 'visibleField', params: { field } }),
                colProp: () => ({ xs: 24, md: 12 }),
                formItemRender: () => {
                }
            },
            {
                key: `${prefix}farmLocations`,
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: 'visibleField', params: { field } }),
                colProp: () => ({ xs: 24, md: 24 }),
                formItemRender: () => { return <div>
                    <CertificateFarmLocationList
                        menuContext={menuContext}
                        viewOnly={viewOnly}
                        useForm={useForm}
                        itemsKey="farmLocations"
                        isTmp={model.isTmp}
                        visibleEdit={visibleEdit}
                    ></CertificateFarmLocationList>
                </div>
                }
            },
            createFieldInput({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: 'visibleField', params: { field } }),
                key: `${prefix}countryOfOriginOfRawMaterial`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t('model.certificateRequest.additionalInformation.countryOfOriginOfRawMaterial'),
                labelRender: ({ field }) => checkTooltipLabel({ field, labelTitle: field.label(), parentModel: model.refParent, model}),
                inputProp: ({ field }) => (lodash.merge({
                    value: model.countryOfOriginOfRawMaterial,
                    'onUpdate:value': value => model.countryOfOriginOfRawMaterial = value,
                    disabled: viewOnly
                }, conditionFormChecker({ props, data, executeKey: 'inputPropField', params: { field } })))
            }),
            {
                key: `${prefix}countryOfOriginOfRawMaterial`,
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: 'visibleField', params: { field } }),
                colProp: () => ({ xs: 24, md: 12 }),
                formItemRender: () => {
                }
            },
            createFieldRadioGroup({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: 'visibleField', params: { field } }),
                key: `${prefix}refCharacterOfProductiveWaterArea`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t('model.certificateRequest.additionalInformation.refCharacterOfProductiveWaterArea'),
                labelRender: ({ field }) => checkTooltipLabel({ field, keySuffix: "value", labelTitle: field.label(), parentModel: model.refParent, model}),
                inputProp: ({ field }) => (lodash.merge({
                    value: model.refCharacterOfProductiveWaterArea,
                    'onUpdate:value': value => model.refCharacterOfProductiveWaterArea = value,
                    disabled: viewOnly,
                    list: callCharacterOfProductiveWaterArea,
                    optKey: "key",
                    optLabel: "value",
                    renderLabel: ({ item }) => <span>{item.value}</span>,
                }, conditionFormChecker({ props, data, executeKey: 'inputPropField', params: { field } }))),
                changeLog: { getValue: ({ record, field }) => lodash.get(record, `${field.key}.value`) }
            }),
            {
                key: `${prefix}refCharacterOfProductiveWaterArea`,
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: 'visibleField', params: { field } }),
                colProp: () => ({ xs: 24, md: 12 }),
                formItemRender: () => {
                }
            },

            createFieldTextArea({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: 'visibleField', params: { field } }),
                key: `${prefix}fishVesselFactoryDetail`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t('model.certificateRequest.additionalInformation.fishVesselFactoryDetail'),
                labelRender: ({ field }) => checkTooltipLabel({ field, labelTitle: field.label(), parentModel: model.refParent, model}),
                inputProp: ({ field }) => (lodash.merge({
                    value: model.fishVesselFactoryDetail,
                    'onUpdate:value': value => model.fishVesselFactoryDetail = value,
                    disabled: viewOnly
                }, conditionFormChecker({ props, data, executeKey: 'inputPropField', params: { field } })))
            }),
            {
                key: `${prefix}fishVesselFactoryDetail`,
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: 'visibleField', params: { field } }),
                colProp: () => ({ xs: 24, md: 12 }),
                formItemRender: () => {
                }
            },
            createFieldTextArea({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: 'visibleField', params: { field } }),
                key: `${prefix}transportVesselDetail`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t('model.certificateRequest.additionalInformation.transportVesselDetail'),
                labelRender: ({ field }) => checkTooltipLabel({ field, labelTitle: field.label(), parentModel: model.refParent, model}),
                inputProp: ({ field }) => (lodash.merge({
                    value: model.transportVesselDetail,
                    'onUpdate:value': value => model.transportVesselDetail = value,
                    disabled: viewOnly
                }, conditionFormChecker({ props, data, executeKey: 'inputPropField', params: { field } })))
            }),
            {
                key: `${prefix}transportVesselDetail`,
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: 'visibleField', params: { field } }),
                colProp: () => ({ xs: 24, md: 12 }),
                formItemRender: () => {
                }
            },
            createFieldTextArea({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: 'visibleField', params: { field } }),
                key: `${prefix}coldStorageMaterialDetail`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t('model.certificateRequest.additionalInformation.coldStorageMaterialDetail'),
                labelRender: ({ field }) => checkTooltipLabel({ field, labelTitle: field.label(), parentModel: model.refParent, model}),
                inputProp: ({ field }) => (lodash.merge({
                    value: model.coldStorageMaterialDetail,
                    'onUpdate:value': value => model.coldStorageMaterialDetail = value,
                    disabled: viewOnly
                }, conditionFormChecker({ props, data, executeKey: 'inputPropField', params: { field } })))
            }),
            {
                key: `${prefix}coldStorageMaterialDetail`,
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: 'visibleField', params: { field } }),
                colProp: () => ({ xs: 24, md: 12 }),
                formItemRender: () => {
                }
            },
            createFieldTextArea({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: 'visibleField', params: { field } }),
                key: `${prefix}coldStorageProductDetail`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t('model.certificateRequest.additionalInformation.coldStorageProductDetail'),
                labelRender: ({ field }) => checkTooltipLabel({ field, labelTitle: field.label(), parentModel: model.refParent, model}),
                inputProp: ({ field }) => (lodash.merge({
                    value: model.coldStorageProductDetail,
                    'onUpdate:value': value => model.coldStorageProductDetail = value,
                    disabled: viewOnly
                }, conditionFormChecker({ props, data, executeKey: 'inputPropField', params: { field } })))
            }),
            {
                key: `${prefix}coldStorageProductDetail`,
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: 'visibleField', params: { field } }),
                colProp: () => ({ xs: 24, md: 12 }),
                formItemRender: () => {
                }
            },
            createFieldInput({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: 'visibleField', params: { field } }),
                key: `${prefix}lotNoOfProduct`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t('model.certificateRequest.additionalInformation.lotNoOfProduct'),
                labelRender: ({ field }) => checkTooltipLabel({ field, labelTitle: field.label(), parentModel: model.refParent, model}),
                inputProp: ({ field }) => (lodash.merge({
                    value: model.lotNoOfProduct,
                    'onUpdate:value': value => model.lotNoOfProduct = value,
                    disabled: viewOnly
                }, conditionFormChecker({ props, data, executeKey: 'inputPropField', params: { field } })))
            }),
            {
                key: `${prefix}lotNoOfProduct`,
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: 'visibleField', params: { field } }),
                colProp: () => ({ xs: 24, md: 12 }),
                formItemRender: () => {
                }
            },
            createFieldInput({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: 'visibleField', params: { field } }),
                key: `${prefix}flightNo`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t('model.certificateRequest.additionalInformation.flightNo'),
                labelRender: ({ field }) => checkTooltipLabel({ field, labelTitle: field.label(), parentModel: model.refParent, model}),
                inputProp: ({ field }) => (lodash.merge({
                    value: model.flightNo,
                    'onUpdate:value': value => model.flightNo = value,
                    disabled: viewOnly
                }, conditionFormChecker({ props, data, executeKey: 'inputPropField', params: { field } })))
            }),
            createFieldInput({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: 'visibleField', params: { field } }),
                key: `${prefix}otherTransportMean`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t('model.certificateRequest.additionalInformation.otherTransportMean'),
                labelRender: ({ field }) => checkTooltipLabel({ field, labelTitle: field.label(), parentModel: model.refParent, model}),
                inputProp: ({ field }) => (lodash.merge({
                    value: model.otherTransportMean,
                    'onUpdate:value': value => model.otherTransportMean = value,
                    disabled: viewOnly
                }, conditionFormChecker({ props, data, executeKey: 'inputPropField', params: { field } })))
            }),

            createFieldInput({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: 'visibleField', params: { field } }),
                key: `${prefix}imsocReference`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t('model.certificateRequest.additionalInformation.imsocReference'),
                labelRender: ({ field }) => checkTooltipLabel({ field, labelTitle: field.label(), parentModel: model.refParent, model}),
                inputProp: ({ field }) => (lodash.merge({
                    value: model.imsocReference,
                    'onUpdate:value': value => model.imsocReference = value,
                    disabled: viewOnly
                }, conditionFormChecker({ props, data, executeKey: 'inputPropField', params: { field } })))
            }),
            {
                key: `${prefix}imsocReference`,
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: 'visibleField', params: { field } }),
                colProp: () => ({ xs: 24, md: 12 }),
                formItemRender: () => {
                }
            },
            createFieldInput({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: 'visibleField', params: { field } }),
                key: `${prefix}coldStore`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t('model.certificateRequest.additionalInformation.coldStore'),
                labelRender: ({ field }) => checkTooltipLabel({ field, labelTitle: field.label(), parentModel: model.refParent, model}),
                inputProp: ({ field }) => (lodash.merge({
                    value: model.coldStore,
                    'onUpdate:value': value => model.coldStore = value,
                    disabled: viewOnly
                }, conditionFormChecker({ props, data, executeKey: 'inputPropField', params: { field } })))
            }),
            {
                key: `${prefix}coldStore`,
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: 'visibleField', params: { field } }),
                colProp: () => ({ xs: 24, md: 12 }),
                formItemRender: () => {
                }
            },
            createFieldCheckbox({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: 'visibleField', params: { field } }),
                key: `${prefix}isForInternalMarket`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t('model.certificateRequest.additionalInformation.isForInternalMarket'),
                labelRender: ({ field }) => checkTooltipLabel({ field, labelTitle: field.label(), parentModel: model.refParent, model}),
                inputProp: ({ field }) => (lodash.merge({
                    checked: model.isForInternalMarket,
                    'onUpdate:checked': checked => model.isForInternalMarket = checked,
                    disabled: viewOnly,
                    text: () => i18n.global.t("model.certificateRequest.additionalInformation.isForInternalMarket")
                }, conditionFormChecker({ props, data, executeKey: 'inputPropField', params: { field } }))),
            }),
            {
                key: `${prefix}isForInternalMarket`,
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: 'visibleField', params: { field } }),
                colProp: () => ({ xs: 24, md: 12 }),
                formItemRender: () => {
                }
            },
            createFieldTextArea({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: 'visibleField', params: { field } }),
                key: `${prefix}additionalVouchTextRemark`,
                colProp: () => ({ xs: 24, md: 16 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 6 }, wrapperCol: { xs: 24, md: 18 } }),
                label: () => i18n.global.t('model.certificateRequest.additionalVouchTextRemark'),
                labelRender: ({ field }) => checkTooltipLabel({ field, labelTitle: field.label(), parentModel: model.refParent, model}),
                inputProp: ({ field }) => (lodash.merge({
                    value: model.additionalVouchTextRemark,
                    'onUpdate:value': value => model.additionalVouchTextRemark = value,
                    disabled: viewOnly
                }, conditionFormChecker({ props, data, executeKey: 'inputPropField', params: { field } })))
            }),
            {
                visible: () => true,
                colProp: () => ({ xs: 24, md: 8 }),
                formItemRender: () => {
                }
            },
            createFieldTextArea({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: 'visibleField', params: { field } }),
                key: `${prefix}replacementRemark`,
                colProp: () => ({ xs: 24, md: 16 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 6 }, wrapperCol: { xs: 24, md: 18 } }),
                label: () => i18n.global.t('model.certificateRequest.replacementRemark'),
                labelRender: ({ field }) => checkTooltipLabel({ field, labelTitle: field.label(), parentModel: model.refParent, model}),
                inputProp: ({ field }) => (lodash.merge({
                    value: model.replacementRemark,
                    'onUpdate:value': value => model.replacementRemark = value,
                    disabled: viewOnly
                }, conditionFormChecker({ props, data, executeKey: 'inputPropField', params: { field } })))
            }),
            {
                visible: () => true,
                colProp: () => ({ xs: 24, md: 8 }),
                formItemRender: () => {
                }
            },
            createFieldTextArea({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: 'visibleField', params: { field } }),
                key: `${prefix}remark`,
                colProp: () => ({ xs: 24, md: 16 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 6 }, wrapperCol: { xs: 24, md: 18 } }),
                label: () => i18n.global.t('model.certificateRequest.remark'),
                labelRender: ({ field }) => checkTooltipLabel({ field, labelTitle: field.label(), parentModel: model.refParent, model}),
                inputProp: ({ field }) => (lodash.merge({
                    value: model.remark,
                    'onUpdate:value': value => model.remark = value,
                    disabled: viewOnly
                }, conditionFormChecker({ props, data, executeKey: 'inputPropField', params: { field } })))
            }),
        ]
    })
}

export const createFieldCorrectionDetails = ({ props, data, key }) => {
    const { viewOnly } = props
    const { useForm } = data
    const { modelRef } = useForm
    const model = key ? lodash.get(modelRef, key) : modelRef
    const prefix = key ? `${key}.` : ''
    return putField({
        data, fields: [
            createFieldTextArea({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: 'visibleField', params: { field } }),
                key: `${prefix}correctionDetail`,
                colProp: () => ({ xs: 24, md: 16 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 6 }, wrapperCol: { xs: 24, md: 18 } }),
                label: () => modelRef?.refRequestChangeInformationTopic?.key === 'Cancel' ? i18n.global.t('model.certificateRequest.cancelDetail') : i18n.global.t('model.certificateRequest.correctionDetail'),
                inputProp: ({ field }) => (lodash.merge({
                    value: model.correctionDetail,
                    'onUpdate:value': value => model.correctionDetail = value,
                    disabled: viewOnly
                }, conditionFormChecker({ props, data, executeKey: 'inputPropField', params: { field } })))
            }),
        ]
    })
}

export const createFieldOfficerPart = ({ props, data, key }) => {
    const { viewOnly } = props
    const { useForm } = data
    const { modelRef } = useForm
    const model = key ? lodash.get(modelRef, key) : modelRef
    const prefix = key ? `${key}.` : ''
    return putField({
        data, fields: [
            createFieldRadioGroup({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: 'visibleField', params: { field } }),
                key: `${prefix}refRequestStatus`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t('model.certificateRequest.refRequestStatus'),
                inputProp: ({ field }) => (lodash.merge({
                    value: model.refRequestStatus,
                    'onUpdate:value': value => {
                        model.refRequestStatus = value
                        // model.certificateApprovalDate =
                        //     value.key !== 'Approve' ? null
                        //         : model.certificateApprovalDate ? model.certificateApprovalDate
                        //             : modelRef.isTmp ? modelRef?.refParent?.certificateApprovalDate
                        //                 : modelRef.loadingDate
                    },
                    disabled: viewOnly,
                    list: ({ searchQuery }) => callStatusRequest({ searchQuery }).then(statuses => statuses.filter(d => ['Approve', 'Reject', 'Cancel'].includes(d.key))),
                    optKey: "key",
                    optLabel: "value",
                    type: "vertical",
                    renderLabel: ({ item }) => model.isTmp ? <span>{item?.attribute?.isTmpText}</span>:<span>{item.value}</span>,
                }, conditionFormChecker({ props, data, executeKey: 'inputPropField', params: { field } }))),
                changeLog: { getValue: ({ record, field }) => lodash.get(record, `${field.key}.value`) }
            }),
            {
                visible: () => true,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemRender: () => { <div></div> }
            },
            createFieldDate({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: 'visibleField', params: { field } }),
                key: `${prefix}certificateApprovalDate`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 8 } }),
                label: () => i18n.global.t('model.certificateRequest.certificateApprovalDate'),
                inputProp: ({ field }) => (lodash.merge({
                    value: model.certificateApprovalDate,
                    'onUpdate:value': value => (model.certificateApprovalDate = value),
                    disabled: viewOnly,
                    locale: 'en',
                }, conditionFormChecker({ props, data, executeKey: 'inputPropField', params: { field } }))),
            }),
            createFieldTextArea({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: 'visibleField', params: { field } }),
                key: `${prefix}approverRemark`,
                colProp: () => ({ xs: 24, md: 16 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 6 }, wrapperCol: { xs: 24, md: 18 } }),
                label: () => i18n.global.t('model.certificateRequest.approverRemark'),
                inputProp: ({ field }) => (lodash.merge({
                    value: model.approverRemark,
                    'onUpdate:value': value => model.approverRemark = value,
                    disabled: viewOnly
                }, conditionFormChecker({ props, data, executeKey: 'inputPropField', params: { field } })))
            }),
        ]
    })
}

export const checkTooltipLabel = ({ field, keySuffix, labelTitle, tooltipTitle, parentModel, model, textSuffix }) => {
    let accessKey = keySuffix ? field.key + "." + keySuffix : field.key
    if( parentModel != null && lodash.get(model, accessKey) != lodash.get(parentModel, accessKey) ) {
        let tooltipString = tooltipTitle ? tooltipTitle : lodash.get(parentModel, accessKey)
        return <span> { labelTitle } {textSuffix}<Tooltip title={tooltipString}><CIcon class="text-danger" file="edit.svg" /></Tooltip></span>
    } else {
        return <span>{labelTitle} {textSuffix}</span>
    }
}

export const formatProducerAddress = ({ modelRef, format }) => {
    if( format === "N") {
        modelRef.producerPlantName = modelRef?.producerPlantName?.split("(").map(d => {
                return lodash.capitalize(d).split(" ")
                    .map(d => lodash.capitalize(d)).join(" ")
            }).join("(")
        modelRef.producerAddress = modelRef?.producerAddress?.split("(").map(d => {
                return lodash.capitalize(d).split(" ")
                    .map(d => lodash.capitalize(d)).join(" ")
            }).join("(")
        modelRef.producerPostcode = modelRef?.producerPostcode?.split("(").map(d => {
                return lodash.capitalize(d).split(" ")
                    .map(d => lodash.capitalize(d)).join(" ")
            }).join("(")
        modelRef.producerPhoneNo = modelRef?.producerPhoneNo?.split("(").map(d => {
                return lodash.capitalize(d).split(" ")
                    .map(d => lodash.capitalize(d)).join(" ")
            }).join("(")
    } else if ( format === "U") {
        modelRef.producerPlantName = modelRef?.producerPlantName?.toUpperCase()
        modelRef.producerAddress = modelRef?.producerAddress?.toUpperCase()
        modelRef.producerPostcode = modelRef?.producerPostcode?.toUpperCase()
        modelRef.producerPhoneNo = modelRef?.producerPhoneNo?.toUpperCase()
    }
}

export const formatExporterAddress = ({ modelRef, format }) => {
    if( format === "N") {
        modelRef.exporterName = modelRef?.exporterName?.split("(").map(d => {
            return lodash.capitalize(d).split(" ")
                .map(d => lodash.capitalize(d)).join(" ")
        }).join("(")
        modelRef.exporterAddress = modelRef?.exporterAddress?.split("(").map(d => {
            return lodash.capitalize(d).split(" ")
                .map(d => lodash.capitalize(d)).join(" ")
        }).join("(")
        modelRef.exporterPostcode = modelRef?.exporterPostcode?.split("(").map(d => {
            return lodash.capitalize(d).split(" ")
                .map(d => lodash.capitalize(d)).join(" ")
        }).join("(")
        modelRef.exporterPhoneNo = modelRef?.exporterPhoneNo?.split("(").map(d => {
            return lodash.capitalize(d).split(" ")
                .map(d => lodash.capitalize(d)).join(" ")
        }).join("(")
    } else if ( format === "U") {
        modelRef.exporterName = modelRef?.exporterName?.toUpperCase()
        modelRef.exporterAddress = modelRef?.exporterAddress?.toUpperCase()
        modelRef.exporterPostcode = modelRef?.exporterPostcode?.toUpperCase()
        modelRef.exporterPhoneNo = modelRef?.exporterPhoneNo?.toUpperCase()
    }
}